/* Bahasa Indonesia — Indonesian */
const id = {
  nav: {
    home: 'Beranda',
    imageConverter: 'Konverter Gambar',
    imageCompressor: 'Kompresor Gambar',
    otherTools: 'Alat Lainnya',
    resizeImage: 'Ubah Ukuran Gambar',
    cropImage: 'Potong Gambar',
    photoEditor: 'Editor Foto',
    removeBackground: 'Hapus Latar Belakang',
    watermarkImage: 'Tanda Air Gambar',
    qrCodeGenerator: 'Generator Kode QR',
    qrCodeScanner: 'Pemindai Kode QR',
    aboutUs: 'Tentang Kami',
    faceBlur: 'Blur Wajah',
  },
  hero: {
    heading: 'Semua Alat Gambar yang Anda Butuhkan',
    subheading: 'Alat online gratis untuk mengonversi, mengompres, mengubah ukuran, memotong, mengedit, dan mentransformasi gambar Anda. Semua pemrosesan terjadi di browser Anda — cepat, privat & aman.',
  },
  tools: {
    compressImage: { title: 'KOMPRES Gambar', desc: 'Kompres JPG, PNG, SVG, dan GIF sambil menghemat ruang dan mempertahankan kualitas.' },
    resizeImage: { title: 'UBAH UKURAN Gambar', desc: 'Tentukan dimensi dengan persentase atau piksel, dan ubah ukuran gambar JPG, PNG, SVG, dan GIF Anda.' },
    cropImage: { title: 'POTONG Gambar', desc: 'Potong JPG, PNG, atau GIF dengan mudah; pilih piksel untuk menentukan persegi panjang atau gunakan editor visual kami.' },
    convertToJpg: { title: 'Konversi ke JPG', desc: 'Ubah gambar format PNG, GIF, TIF, PSD, SVG, WEBP, HEIC, atau RAW ke JPG secara massal dengan mudah.' },
    convertFromJpg: { title: 'Konversi dari JPG', desc: 'Ubah gambar JPG ke PNG dan GIF. Pilih beberapa JPG untuk membuat GIF animasi dalam hitungan detik!' },
    qrCodeGenerator: { title: 'Generator Kode QR', desc: 'Buat kode QR khusus untuk URL, teks, WiFi, kontak, email & peta. Sesuaikan gaya, warna, dan logo.' },
    qrCodeScanner: { title: 'Pemindai Kode QR', desc: 'Pindai kode QR seketika menggunakan kamera atau dengan mengunggah gambar. Deteksi URL, teks, WiFi, kontak & lainnya.' },
    blurFace: { title: 'Blur Wajah', desc: 'Deteksi dan blur wajah secara otomatis dalam gambar untuk privasi. Sesuaikan intensitas blur, bentuk, atau tambahkan overlay emoji.' },
    removeBackground: { title: 'Hapus Latar Belakang', desc: 'Hapus latar belakang gambar dengan akurasi tinggi secara cepat. Deteksi objek dan potong latar belakang secara instan.' },
    watermarkImage: { title: 'TANDA AIR Gambar', desc: 'Tambahkan gambar atau teks ke gambar Anda dalam hitungan detik. Pilih tipografi, transparansi, dan posisi.' },
  },
  whyChoose: {
    label: 'Mengapa Memilih Kami',
    heading: 'Cara Lebih Cerdas Mengedit Gambar',
    subheading: 'Dipercaya oleh ribuan kreator, desainer, dan pengembang di seluruh dunia. Inilah mengapa photremium.com menjadi tujuan utama pengeditan gambar.',
    reasons: {
      fast: { title: 'Sangat Cepat', desc: 'Semua pemrosesan terjadi langsung di browser Anda. Tidak ada upload file ke server eksternal — hasilnya muncul dalam milidetik.' },
      private: { title: '100% Privat & Aman', desc: 'File Anda tidak pernah meninggalkan perangkat Anda. Kami tidak menyimpan, berbagi, atau mengakses gambar Anda. Privasi lengkap dijamin.' },
      noLimits: { title: 'Tanpa Batas, Tanpa Daftar', desc: 'Gunakan setiap alat sebanyak yang Anda mau — sepenuhnya gratis. Tidak diperlukan akun, tidak ada tanda air, tidak ada biaya tersembunyi.' },
      quality: { title: 'Kualitas Profesional', desc: 'Algoritma kami menghasilkan kualitas setara studio. Kompres tanpa kehilangan kualitas yang terlihat, konversi dengan kesetiaan sempurna.' },
      batch: { title: 'Pemrosesan Batch', desc: 'Tangani beberapa file sekaligus. Konversi, kompres, atau ubah ukuran seluruh folder gambar dalam satu operasi.' },
      everywhere: { title: 'Bekerja di Mana Saja', desc: 'Desain responsif penuh bekerja di desktop, tablet, dan ponsel. Tidak perlu mengunduh atau menginstal apa pun.' },
    },
    stats: {
      imagesProcessed: 'Gambar Diproses',
      countriesServed: 'Negara Dilayani',
      uptime: 'Waktu Aktif',
      freeTools: 'Alat Gratis',
    },
  },
  footer: {
    tagline: 'Alat gambar online gratis — konversi, kompres, ubah ukuran, potong & edit gambar Anda dalam hitungan detik. Tidak diperlukan pendaftaran.',
    imageTools: 'Alat Gambar',
    moreTools: 'Alat Lainnya',
    company: 'Perusahaan',
    contact: 'Kontak',
    allRightsReserved: 'Hak cipta dilindungi.',
    privacyPolicy: 'Kebijakan Privasi',
    termsOfService: 'Ketentuan Layanan',
  },
  faq: {
    badge: 'FAQ',
    heading: 'Pertanyaan yang Sering Diajukan',
    subheading: 'Jawaban cepat untuk pertanyaan umum tentang alat ini.',
    stillHaveQuestions: 'Masih punya pertanyaan? Kami siap membantu!',
    reachOut: 'Hubungi Tim Kami',
    questionHeader: 'Pertanyaan',
  },

  contactForm: {
    badge: 'Hubungi Kami',
    title: 'Hubungi Kami',
    subtitle: 'Kami ingin mendengar dari Anda. Kirimkan pesan!',
    nameLabel: 'Nama',
    namePlaceholder: 'Nama lengkap Anda',
    emailLabel: 'Email',
    emailPlaceholder: 'anda@email.com',
    subjectLabel: 'Subjek',
    subjectPlaceholder: 'Ini tentang apa?',
    messageLabel: 'Pesan',
    messagePlaceholder: 'Tulis pesan Anda di sini…',
    errName: 'Nama wajib diisi',
    errEmail: 'Email wajib diisi',
    errEmailInvalid: 'Masukkan email yang valid',
    errSubject: 'Subjek wajib diisi',
    errMessage: 'Pesan wajib diisi',
    sending: 'Mengirim…',
    send: 'Kirim Pesan',
    successTitle: 'Pesan Terkirim!',
    successMsg: 'Terima kasih telah menghubungi kami. Kami akan segera membalas.',
    sendAnother: 'Kirim Lagi',
    sendError: 'Terjadi kesalahan. Silakan coba lagi.',
  },

  about: {
    label: 'Tentang Kami',
    heading: 'Dibangun untuk Kreator, oleh Kreator',
    subheading: 'Kami percaya alat gambar yang powerful harus gratis, cepat, dan dapat diakses oleh semua orang.',
    missionTitle: 'Misi Kami',
    missionText: 'photremium.com diciptakan dengan tujuan sederhana: memberikan pengalaman pengeditan gambar yang paling intuitif, tercepat, dan paling privat di web. Kami memproses semuanya langsung di browser Anda — file Anda tidak pernah meninggalkan perangkat Anda. Tidak ada akun, tidak ada batasan, tidak ada kompromi.',
    privacyTitle: 'Privasi Pertama',
    privacyText: 'Kami tidak pernah mengunggah, menyimpan, atau memproses gambar Anda di server jarak jauh. Semuanya tetap ada di perangkat Anda.',
    techTitle: 'Teknologi Modern',
    techText: 'Dibangun dengan teknologi web mutakhir termasuk WebAssembly, Canvas API, dan React modern untuk performa puncak.',
    communityTitle: 'Didorong Komunitas',
    communityText: 'Setiap fitur yang kami bangun terinspirasi dari umpan balik pengguna nyata. Saran Anda membentuk peta jalan kami.',
    globalTitle: 'Jangkauan Global',
    globalText: 'Digunakan oleh kreator di lebih dari 120 negara. Tersedia dalam berbagai bahasa dengan pengiriman CDN yang sangat cepat.',
  },
  seo: {
    homeTitle: 'photremium.com — Konverter, Kompresor & Editor Gambar Online Gratis',
    homeDesc: 'Konversi, kompres, ubah ukuran, potong, dan edit gambar secara online gratis. Cepat, privat, dan aman — semua pemrosesan terjadi di browser Anda.',
    homeKeywords: 'konverter gambar, kompresor gambar, ubah ukuran gambar, potong gambar, editor foto, alat gambar online, alat gambar gratis',
    aboutTitle: 'Tentang photremium.com — Misi & Cerita Kami',
    aboutDesc: 'Pelajari tentang photremium.com, toolkit gambar online gratis yang dipercaya jutaan orang. Misi kami adalah membuat pengeditan gambar profesional dapat diakses semua orang.',
    aboutKeywords: 'tentang photremium.com, perusahaan alat gambar, editor gambar gratis, tentang kami',
  },
          privacyPolicyPage: {
    seo: {
      title: 'Kebijakan Privasi — Photremium | Tanpa Pengunggahan Server, Tanpa Penyimpanan Data',
      description: 'Kebijakan Privasi Photremium menjelaskan bagaimana kami melindungi privasi Anda. Semua pemrosesan gambar terjadi 100% di browser Anda — tidak ada file yang diunggah ke server mana pun, tidak ada data pribadi yang dikumpulkan, tidak ada pelacakan.',
      ogTitle: 'Kebijakan Privasi — Photremium | Tanpa Unggahan, Tanpa Penyimpanan',
      ogDescription: 'File Anda tetap ada di perangkat Anda. Photremium memproses semua gambar secara lokal di browser Anda tanpa kontak server, tanpa penyimpanan data, dan tanpa pelacakan.',
      twitterTitle: 'Kebijakan Privasi — Photremium',
      twitterDescription: '100% alat gambar berbasis browser. Tidak ada unggahan, tidak ada penyimpanan, tidak ada pelacakan. Baca kebijakan privasi lengkap kami.',
      schemaName: 'Kebijakan Privasi - Photremium',
      schemaDescription: 'Kebijakan Privasi Photremium - tidak ada unggahan server, tidak ada data yang disimpan, 100% pemrosesan gambar dalam browser.'
    },
    hero: {
      badge: 'Kebijakan Privasi',
      titlePrefix: 'Privasi Anda Adalah Kami',
      titleHighlight: 'Prioritas Utama',
      subPrefix: 'photremium.com dibangun berdasarkan prinsip sederhana —',
      subStrong: 'file Anda tidak pernah meninggalkan perangkat Anda',
      subSuffix: 'Setiap alat gambar di situs ini berjalan sepenuhnya di dalam browser Anda. Tidak ada unggahan. Tidak ada awan. Tidak ada kompromi.',
      effectiveLabel: 'Efektif',
      lastUpdatedLabel: 'Terakhir diperbarui',
      worldwideLabel: 'Berlaku di seluruh dunia'
    },
    trustCards: [
      {
        title: 'Tidak Ada Unggahan Server',
        desc: 'File Anda tidak pernah meninggalkan perangkat Anda. Semua pemrosesan 100% dilakukan di browser.'
      },
      {
        title: 'Penyimpanan Data Nol',
        desc: 'Kami tidak menyimpan apa pun tentang Anda, gambar Anda, atau aktivitas Anda.'
      },
      {
        title: 'Tidak Ada Pelacakan',
        desc: 'Tidak ada pelacakan perilaku, tidak ada sidik jari, tidak ada pembuatan profil.'
      },
      {
        title: 'Ramah GDPR',
        desc: 'Dirancang dari awal untuk menghormati peraturan privasi global.'
      }
    ],
    contentsTitle: 'Isi',
    toc: {
      overview: 'Ringkasan',
      'no-upload': 'Tidak Ada Pemrosesan Server',
      'data-collect': 'Data yang Kami Kumpulkan',
      cookies: 'Cookie & Penyimpanan',
      'third-party': 'Layanan Pihak Ketiga',
      analytics: 'Analisis',
      children: 'Privasi Anak',
      rights: 'Hak Anda',
      security: 'Keamanan',
      changes: 'Perubahan Kebijakan',
      contact: 'Hubungi kami'
    },
    sections: {
      overview: {
        title: '1. Ikhtisar',
        subtitle: 'Apa saja yang tercakup dalam kebijakan ini',
        p1Prefix: 'Kebijakan Privasi ini menjelaskan caranya',
        p1Middle: '("kami", "kami", atau "milik kami") menangani - atau lebih tepatnya,',
        p1Italic: 'tidak menangani',
        p1Suffix: 'informasi pribadi Anda saat Anda menggunakan alat gambar online gratis kami di',
        p2: 'Tidak seperti aplikasi web tradisional yang mengirim file ke server jarak jauh untuk diproses, photremium.com menggunakan API browser modern (Canvas API, WebAssembly, WebWorkers) untuk melakukan setiap operasi secara lokal di perangkat Anda. Hasilnya: tidak ada transmisi data, tidak ada penyimpanan, tidak ada risiko.',
        calloutLabel: 'Ringkasan bahasa Inggris biasa:',
        calloutText: 'Kami tidak dapat melihat gambar Anda, kami tidak menginginkannya, dan teknologi kami dirancang secara khusus sehingga kami tidak akan pernah bisa melihatnya.'
      },
      noUpload: {
        title: '2. Tidak Ada Pemrosesan Server — Selamanya',
        subtitle: 'Bagaimana sebenarnya alat kami bekerja',
        introPrefix: 'Setiap alat di photremium.com — pengonversi gambar, kompresor, pengubah ukuran, penghapus latar belakang, pengaburan wajah, tanda air, pemotongan, dan alat kode QR — memproses file Anda',
        introStrong: '100% di dalam browser web Anda',
        introSuffix: 'menggunakan JavaScript sisi klien dan WebAssembly.',
        points: [
          {
            label: 'Tidak ada pengunggahan file yang pernah terjadi.',
            text: 'Saat Anda memilih file, file tersebut dibaca oleh File API browser Anda dan diproses di memori — file tersebut tidak pernah dikirim melalui jaringan.'
          },
          {
            label: 'Tidak ada server yang menerima gambar Anda.',
            text: 'CDN kami hanya melayani aset HTML, CSS, dan JavaScript yang diperlukan untuk menjalankan aplikasi — bukan file Anda.'
          },
          {
            label: 'Tidak ada penyimpanan sementara.',
            text: 'Hasil yang diproses hanya ada di memori browser Anda dan dilepaskan saat Anda menutup atau keluar dari halaman.'
          },
          {
            label: 'Bekerja offline.',
            text: 'Sebagian besar alat terus berfungsi tanpa koneksi internet setelah halaman pertama dimuat — bukti lebih lanjut tidak ada server yang terlibat.'
          }
        ],
        callout: 'Anda dapat memverifikasinya sendiri: buka tab Jaringan browser Anda di Alat Pengembang, pilih gambar, dan konfirmasikan bahwa tidak ada data file yang dikirimkan ke server eksternal mana pun.'
      },
      dataCollect: {
        title: '3. Data yang Kami Kumpulkan (dan Tidak Kami Kumpulkan)',
        subtitle: 'Transparansi penuh pada praktik data',
        headers: {
          type: 'Tipe Data',
          collected: 'Dikumpulkan?',
          whereWhy: 'Dimana / Mengapa'
        },
        rows: [
          {
            type: 'Gambar/file Anda',
            badge: 'Tidak pernah',
            variant: 'hijau',
            showX: true,
            whereWhy: 'Diproses sepenuhnya di browser Anda — tidak pernah dikirimkan'
          },
          {
            type: 'Nama/alamat email',
            badge: 'Tidak pernah',
            variant: 'hijau',
            showX: true,
            whereWhy: 'Tidak diperlukan akun atau pendaftaran untuk menggunakan alat apa pun'
          },
          {
            type: 'alamat IP',
            badge: 'Minimal',
            variant: 'abu-abu',
            showX: false,
            whereWhy: 'Log server web standar disimpan <= 30 hari, tidak terikat dengan identitas'
          },
          {
            type: 'Jenis peramban/OS',
            badge: 'Minimal',
            variant: 'abu-abu',
            showX: false,
            whereWhy: 'Dikirim oleh browser Anda secara otomatis; hanya digunakan untuk kompatibilitas'
          },
          {
            type: 'Halaman yang dikunjungi / diklik',
            badge: 'Diagregasi',
            variant: 'biru',
            showX: false,
            whereWhy: 'Hanya analitik anonim (tidak ada identifikasi pribadi)'
          },
          {
            type: 'Preferensi bahasa',
            badge: 'Hanya lokal',
            variant: 'biru',
            showX: false,
            whereWhy: 'Disimpan ke Penyimpanan lokal di perangkat Anda — tidak pernah dikirimkan kepada kami'
          },
          {
            type: 'Data pembayaran/keuangan',
            badge: 'Tidak pernah',
            variant: 'hijau',
            showX: true,
            whereWhy: 'photremium.com sepenuhnya gratis tanpa perlu pembayaran'
          }
        ]
      },
      cookies: {
        title: '4. Cookie & Penyimpanan Lokal',
        subtitle: 'Apa yang disimpan di perangkat Anda',
        intro: 'photremium.com tidak menggunakan cookie iklan, tidak ada cookie pelacakan lintas situs, dan tidak ada cookie pihak ketiga. Satu-satunya penyimpanan browser yang kami gunakan adalah untuk fungsionalitas situs yang penting.',
        points: [
          {
            label: 'Preferensi bahasa',
            text: 'Disimpan di Penyimpanan lokal sehingga situs mengingat bahasa pilihan Anda di antara kunjungan. Tidak pernah dikirim ke server kami.'
          },
          {
            label: 'Preferensi Tema / UI',
            text: 'Jika Anda menetapkan preferensi tampilan, preferensi tersebut akan disimpan secara lokal di perangkat Anda saja.'
          },
          {
            label: 'Tidak ada cookie sesi.',
            text: 'photremium.com tidak memiliki sistem login, jadi tidak ada cookie ID sesi yang pernah ditulis.'
          }
        ],
        callout: 'Anda dapat menghapus semua penyimpanan lokal photremium.com kapan saja melalui pengaturan browser Anda (Pengaturan -> Privasi -> Hapus data penelusuran -> Data cache & cookie). Melakukan hal itu tidak berpengaruh pada kemampuan Anda menggunakan alat tersebut.'
      },
      thirdParty: {
        title: '5. Layanan Pihak Ketiga',
        subtitle: 'Layanan eksternal yang kami gunakan dan alasannya',
        intro: 'photremium.com menggunakan serangkaian layanan pihak ketiga tepercaya hanya untuk infrastruktur dan kinerja. Tak satu pun dari layanan ini menerima gambar Anda atau informasi identitas pribadi apa pun.',
        headers: {
          service: 'Melayani',
          purpose: 'Tujuan',
          dataShared: 'Data Dibagikan',
          privacyPolicy: 'Kebijakan Privasi'
        },
        rows: [
          {
            service: 'Halaman Cloudflare',
            purpose: 'Hosting & pengiriman CDN aset situs',
            dataShared: 'Alamat IP, header HTTP (standar)',
            privacyLink: 'https://www.cloudflare.com/privacypolicy/',
            privacyText: 'cloudflare.com/privacypolicy'
          },
          {
            service: 'Font Luar Biasa',
            purpose: 'Font ikon dimuat dari CDN',
            dataShared: 'Alamat IP (hanya permintaan CSS)',
            privacyLink: 'https://fontawesome.com/privacy',
            privacyText: 'fontawesome.com/privacy'
          },
          {
            service: 'Google Font',
            purpose: 'Pemuatan jenis huruf (jika ada)',
            dataShared: 'Alamat IP (hanya permintaan font)',
            privacyLink: 'https://policies.google.com/privacy',
            privacyText: 'policies.google.com'
          }
        ],
        outro: 'Kami tidak membagikan data Anda kepada pengiklan, pialang data, atau pihak ketiga mana pun di luar penyedia infrastruktur yang tercantum di atas.'
      },
      analytics: {
        title: '6. Analisis',
        subtitle: 'Data penggunaan agregat yang menghormati privasi',
        introPrefix: 'Untuk memahami alat mana yang populer dan cara meningkatkan situs, kami dapat mengumpulkannya',
        introStrong: 'dikumpulkan, dianonimkan',
        introSuffix: 'statistik penggunaan seperti:',
        points: [
          'Jumlah tampilan halaman per alat (tidak ada identifikasi pengguna)',
          'Sumber rujukan (misalnya pencarian Google, tautan langsung) — tidak ada data pribadi',
          'Data geografis tingkat negara (bukan kota atau lokasi tepatnya)',
          'Jenis browser/perangkat untuk analisis kompatibilitas'
        ],
        calloutLabel: 'Tidak ada data yang ditautkan ke Anda secara pribadi.',
        calloutText: 'Kami tidak menggunakan Google Analytics atau Meta Pixel. Analisis apa pun yang kami gunakan adalah alat yang mengutamakan privasi (misalnya Masuk Akal atau serupa).'
      },
      children: {
        title: '7. Privasi Anak',
        subtitle: 'COPPA & kepatuhan keselamatan anak',
        p1: 'photremium.com tidak dengan sengaja mengumpulkan informasi pribadi apa pun dari anak-anak di bawah usia 13 tahun (atau 16 tahun di Uni Eropa berdasarkan GDPR). Karena kami tidak mengumpulkan data pribadi dari pengguna mana pun, tidak ada tindakan khusus yang dapat dilakukan untuk pengguna muda — situs ini sama amannya bagi semua orang.',
        p2Prefix: 'Jika Anda yakin ada anak yang mengirimkan informasi pribadi melalui formulir kontak kami, harap segera menghubungi kami di',
        p2Suffix: 'dan kami akan segera menghapusnya.'
      },
      rights: {
        title: '8. Hak Anda',
        subtitle: 'GDPR, CCPA, dan hak privasi global',
        intro: 'Karena photremium.com tidak mengumpulkan informasi identitas pribadi, sebagian besar hak subjek data berlaku secara sepele — tidak ada data tentang Anda yang dapat diakses, diperbaiki, atau dihapus. Meskipun demikian, kami sepenuhnya mengakui dan menghormati hak-hak berikut:',
        points: [
          {
            label: 'Hak untuk mengakses',
            text: 'Anda dapat meminta salinan data apa pun yang kami miliki tentang Anda. (Tidak ada yang lain selain log yang dianonimkan.)'
          },
          {
            label: 'Hak untuk dikoreksi',
            text: 'Anda dapat meminta koreksi atas data pribadi yang tidak akurat.'
          },
          {
            label: 'Hak untuk menghapus (“Hak untuk dilupakan”)',
            text: 'Anda dapat meminta penghapusan data pribadi apa pun yang kami simpan (GDPR Pasal 17, CCPA).'
          },
          {
            label: 'Hak untuk menolak/memilih keluar',
            text: 'Anda dapat membatalkan pengumpulan analisis apa pun di masa mendatang dengan menggunakan alat penyisihan atau pemblokiran iklan di tingkat browser.'
          },
          {
            label: 'Hak atas portabilitas data',
            text: 'Semua pekerjaan Anda diunduh langsung ke perangkat Anda — tidak perlu permintaan ekspor.'
          }
        ],
        callout: 'Hak-hak ini berlaku untuk semua pengguna di seluruh dunia, apa pun yurisdiksinya — kami menerapkan standar tertinggi (GDPR) sebagai pedoman dasar kami.'
      },
      security: {
        title: '9. Keamanan',
        subtitle: 'Bagaimana kami melindungi pengalaman Anda',
        intro: 'Data yang paling aman adalah data yang tidak pernah dikumpulkan. Arsitektur sisi klien photremium.com berarti pelanggaran server tidak dapat mengekspos file Anda karena file Anda tidak pernah ada di server kami. Langkah-langkah keamanan tambahan meliputi:',
        points: [
          {
            label: 'Penegakan HTTPS',
            text: 'Semua lalu lintas antara browser Anda dan CDN kami dienkripsi melalui TLS 1.2+ dengan HSTS.'
          },
          {
            label: 'Kebijakan Keamanan Konten (CSP)',
            text: 'Header yang ketat mencegah pembuatan skrip lintas situs dan injeksi skrip sebaris.'
          },
          {
            label: 'Audit ketergantungan rutin',
            text: 'Kami mengaudit dan memperbarui paket npm secara rutin untuk menambal kerentanan yang diketahui.'
          }
        ],
        disclosurePrefix: 'Pengungkapan yang bertanggung jawab',
        disclosureTextPrefix: 'Menemukan masalah keamanan? Email kami di',
        disclosureTextSuffix: 'dan kami akan merespons dalam waktu 48 jam.'
      },
      changes: {
        title: '10. Perubahan Kebijakan Ini',
        subtitle: 'Cara kami menangani pembaruan kebijakan',
        intro: 'Kami dapat memperbarui Kebijakan Privasi ini dari waktu ke waktu untuk mencerminkan perubahan dalam praktik, alat, atau persyaratan hukum kami. Ketika kita melakukan:',
        points: [
          {
            label: '"Terakhir Diperbarui"',
            text: 'tanggal di bagian atas halaman ini akan direvisi.'
          },
          {
            label: 'Perubahan materi',
            text: 'akan dikomunikasikan melalui pemberitahuan yang jelas di halaman beranda setidaknya selama 30 hari.'
          },
          {
            label: 'Versi sebelumnya',
            text: 'kebijakan ini akan diarsipkan dan tersedia berdasarkan permintaan.'
          }
        ],
        outro: 'Penggunaan berkelanjutan dari photremium.com setelah perubahan dipublikasikan merupakan penerimaan terhadap kebijakan yang diperbarui. Kami mendorong Anda untuk meninjau halaman ini secara berkala.'
      },
      contact: {
        title: '11. Permintaan Kontak & Data',
        subtitle: 'Hubungi kami tentang privasi',
        p1Prefix: 'Untuk pertanyaan, kekhawatiran, atau permintaan data formal apa pun terkait Kebijakan Privasi ini, silakan hubungi kami. Kami bertujuan untuk menanggapi semua pertanyaan terkait privasi di dalamnya',
        p1Strong: '5 hari kerja'
      }
    },
    footer: {
      privacyQuestionsTitle: 'Pertanyaan Privasi?',
      privacyQuestionsDesc: 'Kirimkan pertanyaan privasi, permintaan data, atau kekhawatiran Anda kepada kami dan kami akan segera meresponsnya.',
      versionHistoryTitle: 'Riwayat Versi',
      v2Label: 'v2.0 — Major rewrite',
      v11Label: 'v1.1 — Added CCPA rights',
      v10Label: 'v1.0 — Initial policy'
    }
  },
/* ————— Common / shared UI strings ————— */
  common: {
    new: 'Baru!',
    download: 'Unduh',
    downloadAll: 'Unduh Semua',
    downloadAs: 'Unduh sebagai:',
    zip: 'ZIP',
    separate: 'Terpisah',
    upload: 'Unggah',
    dragDrop: 'Seret & lepas gambar di sini, atau klik untuk menelusuri',
    remove: 'Hapus',
    reset: 'Atur Ulang',
    apply: 'Terapkan',
    cancel: 'Batal',
    clear: 'Bersihkan',
    close: 'Tutup',
    save: 'Simpan',
    processing: 'Memproses...',
    noFiles: 'Tidak ada file yang dipilih',
    selectFiles: 'Pilih file',
    or: 'atau',
    browseFiles: 'telusuri file',
    dropHere: 'Letakkan gambar Anda di sini',
    chooseFiles: 'Pilih File',
    pasteHint: 'Anda juga dapat menempel gambar dengan',
    quality: 'Kualitas',
    width: 'Lebar',
    height: 'Tinggi',
    format: 'Format',
    compression: 'Kompresi',
    preview: 'Pratinjau',
    original: 'Asli',
    result: 'Hasil',
    before: 'Sebelum',
    after: 'Sesudah',
    startOver: 'Mulai Ulang',
    startOverConfirm: 'Apakah Anda yakin ingin menghapus semua gambar dan memulai ulang?',
    addMoreImages: 'Tambah Gambar Lagi',
    addImage: 'Tambah Gambar',
    images: 'Gambar',
    totalSize: 'Ukuran Total',
    size: 'Ukuran',
    type: 'Tipe',
    unsavedEdits: 'Anda memiliki suntingan yang belum disimpan. Tinggalkan halaman ini?',
    compareSlider: 'Geser perbandingan',
    toggleToolsPanel: 'Tampilkan/sembunyikan panel alat',
    closePanel: 'Tutup panel',
    zoomIn: 'Perbesar',
    zoomOut: 'Perkecil',
    fit: 'Sesuaikan',
    none: 'Tidak Ada',
  },
  compressor: {
    seo: {
      uploadTitle: 'Kompresor Gambar — Kompres JPG, PNG, SVG, GIF Online Gratis | photremium.com',
      uploadDesc: 'Kompres gambar JPG, PNG, SVG, dan GIF secara online gratis. Kurangi ukuran file hingga 80% sambil mempertahankan kualitas visual. Tidak diperlukan pendaftaran.',
      uploadKeywords: 'kompresor gambar, kompres jpg, kompres png, kurangi ukuran gambar, optimasi gambar, kompres foto online gratis',
      workspaceTitle: 'Mengompres Gambar — Kompresor Gambar photremium.com',
      workspaceDesc: 'Sesuaikan tingkat kompresi dan unduh gambar yang telah dioptimalkan. Pratinjau langsung dan estimasi ukuran.',
      workspaceKeywords: 'kompres gambar, slider kompresi gambar, kompres gambar massal, alat optimasi gambar',
    },
    title: 'Kompresor Gambar',
    desc: 'Kompres gambar JPG, PNG & GIF hingga 80% lebih kecil. Cepat, privat — berjalan sepenuhnya di browser Anda.',
    toCompress: 'untuk dikompres',
    compressionForAll: 'Kompresi untuk semua gambar',
    summary: 'Ringkasan',
    originalSize: 'Ukuran Asli',
    compressed: 'Terkompresi',
    saved: 'Dihemat',
    compressionLabel: 'Kompresi:',
    compressing: 'Mengompres…',
    compressDownload: 'Kompres & Unduh',
    lowQualityWarning: 'Kompresi tinggi dapat mengurangi kejernihan gambar secara signifikan.',
    blog: {
      tocTitle: 'Daftar Isi',
      title: 'Blog Kompresor Gambar',
      formatsIntro: 'Alat kami mendukung semua format gambar, jadi Anda bisa mengompres gambar apa pun dengan lancar. Daftar format lengkap ada di bawah ini:',
      sections: [
        {
          id: 'imgcomp-card-1',
          title: '1. Apa itu kompresor gambar?',
          paragraphs: [
            'Kompresor gambar adalah perangkat lunak atau layanan online yang mengurangi ukuran file gambar sambil mempertahankan kualitas visualnya. Namun, jika gambar dikompres terlalu tinggi, kualitasnya bisa turun secara jelas.',
          ],
          listTitle: 'JENIS:',
          bullets: [
            'Kompresi lossy: ukuran gambar dikurangi dengan menghapus sebagian data gambar. Kualitas dapat menurun, tetapi sering kali tidak terlalu terlihat oleh mata manusia.',
            'Kompresi lossless: hanya mengurangi ukuran file tanpa memengaruhi kualitas visual gambar.',
          ],
        },
        {
          id: 'imgcomp-card-2',
          title: '2. Mengapa memilih alat kami?',
          bullets: [
            'Alat kompresor gambar berbasis AI kami bekerja mulus di semua perangkat untuk memberikan hasil terbaik.',
            'Anda dapat mengompres banyak gambar (bahkan 100+ gambar) sekaligus hanya dengan satu klik.',
            'Tidak perlu mengunggah gambar ke server kami. Semua gambar dikompres secara lokal di browser Anda.',
            'Alat kompresor gambar kami sepenuhnya gratis selamanya. Anda juga bisa membagikannya ke teman-teman Anda.',
            'Anda dapat memilih persentase kompresi sesuai kebutuhan.',
          ],
        },
        {
          id: 'imgcomp-card-3',
          title: '3. Panduan langkah demi langkah',
          steps: [
            {
              heading: '1. Pilih gambar yang ingin Anda kompres.',
              bullets: [
                'Seret dan lepas gambar ke kotak unggah.',
                'Anda juga dapat menyalin gambar lalu menempelkannya ke kotak dengan (Ctrl + V).',
                'Anda juga bisa menggunakan penjelajah file dengan klik tombol pilih.',
              ],
            },
            {
              heading: '2. Lalu pilih persentase kompresi.',
              bullets: [
                'Slider horizontal memberi pengalaman yang nyaman untuk memilih persentase kompresi. Ikuti rentang berikut untuk hasil yang lebih akurat.',
              ],
              table: {
                headers: ['Persentase Kompresi', 'Hasil'],
                rows: [
                  ['1%  sampai  40%', 'Kualitas terbaik'],
                  ['41%  sampai  60%', 'Kualitas normal (Disarankan)'],
                  ['61%  sampai  100%', 'Kualitas rendah'],
                ],
              },
            },
            {
              heading: '3. Periksa ruang yang Anda hemat.',
              paragraphs: [
                'Semua metrik ukuran ditampilkan secara real-time. Anda bisa melihat jelas berapa banyak ruang yang dihemat dari total ukuran, lalu menyesuaikan level kompresi sesuai kebutuhan.',
              ],
            },
            {
              heading: '4. Pilih opsi unduhan dari tombol toggle.',
              bullets: [
                'ZIP: Jika Anda mengompres banyak gambar, opsi ini akan muncul. Memilih ZIP akan mengarsipkan semua gambar terkompresi ke dalam satu file ZIP (disarankan untuk jumlah gambar besar).',
                'Terpisah: Memilih opsi ini akan mengunduh semua gambar secara terpisah, bukan sebagai satu file ZIP (disarankan untuk jumlah gambar kecil, kurang dari 10).',
              ],
            },
            {
              heading: '5. Kompres & unduh gambar.',
              paragraphs: [
                'Tombol ini akan mengunduh semua gambar terkompresi secara otomatis sesuai opsi unduhan yang Anda pilih.',
              ],
            },
          ],
        },
        {
          id: 'imgcomp-card-4',
          title: '4. Manfaat kompresor gambar.',
          bullets: [
            'Mengurangi biaya penyimpanan: kompresi gambar secara signifikan menurunkan ukuran file sehingga menghemat ruang.',
            'Mempercepat pemuatan: gambar terkompresi lebih cepat dimuat dan meningkatkan pengalaman pengguna situs atau aplikasi.',
            'Solusi batas lampiran Gmail: karena Gmail membatasi lampiran hingga 25MB, kompresi membantu Anda mengirim lebih banyak file.',
            'Berbagi dan transfer lebih cepat: file besar memerlukan waktu lebih lama untuk dikirim; kompresi menghemat waktu dan kuota data.',
            'Optimasi presentasi: presentasi dengan gambar tak terkompresi bisa sangat berat, sedangkan gambar terkompresi membuat ukuran file jauh lebih kecil.',
          ],
        },
        {
          id: 'imgcomp-card-5',
          title: '5. Format yang didukung.',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },
  converter: {
    seo: {
      uploadTitle: 'Konverter Gambar — Konversi PNG, JPG, WEBP, GIF, SVG Online Gratis | photremium.com',
      uploadDesc: 'Konversi gambar antara JPG, PNG, WEBP, GIF, SVG, TIFF, BMP dan lainnya. Konverter format gambar online gratis — cepat, privat, tidak diperlukan pendaftaran.',
      uploadKeywords: 'konverter gambar, konversi png ke jpg, jpg ke png, konverter webp, konverter format gambar, konverter gambar online gratis',
      workspaceKeywords: 'konversi gambar, konverter format gambar, konversi gambar massal',

      routeKeywords: {

        'png-to-jpg': 'png untuk dikonversi jpg, png to jpg, konverter gambar, konversi png ke jpg, jpg ke png, konverter webp, konverter format gambar, konverter gambar online gratis',

        'jpg-to-png': 'jpg untuk dikonversi png, jpg to png, konverter gambar, konversi png ke jpg, jpg ke png, konverter webp, konverter format gambar, konverter gambar online gratis',

        'png-to-webp': 'png untuk dikonversi webp, png to webp, konverter gambar, konversi png ke jpg, jpg ke png, konverter webp, konverter format gambar, konverter gambar online gratis',

        'jpg-to-webp': 'jpg untuk dikonversi webp, jpg to webp, konverter gambar, konversi png ke jpg, jpg ke png, konverter webp, konverter format gambar, konverter gambar online gratis',

        'webp-to-jpg': 'webp untuk dikonversi jpg, webp to jpg, konverter gambar, konversi png ke jpg, jpg ke png, konverter webp, konverter format gambar, konverter gambar online gratis',

        'webp-to-png': 'webp untuk dikonversi png, webp to png, konverter gambar, konversi png ke jpg, jpg ke png, konverter webp, konverter format gambar, konverter gambar online gratis',

        'gif-to-jpg': 'gif untuk dikonversi jpg, gif to jpg, konverter gambar, konversi png ke jpg, jpg ke png, konverter webp, konverter format gambar, konverter gambar online gratis',

        'gif-to-png': 'gif untuk dikonversi png, gif to png, konverter gambar, konversi png ke jpg, jpg ke png, konverter webp, konverter format gambar, konverter gambar online gratis',

        'bmp-to-jpg': 'bmp untuk dikonversi jpg, bmp to jpg, konverter gambar, konversi png ke jpg, jpg ke png, konverter webp, konverter format gambar, konverter gambar online gratis',

        'bmp-to-png': 'bmp untuk dikonversi png, bmp to png, konverter gambar, konversi png ke jpg, jpg ke png, konverter webp, konverter format gambar, konverter gambar online gratis',

        'svg-to-png': 'svg untuk dikonversi png, svg to png, konverter gambar, konversi png ke jpg, jpg ke png, konverter webp, konverter format gambar, konverter gambar online gratis',

        'svg-to-jpg': 'svg untuk dikonversi jpg, svg to jpg, konverter gambar, konversi png ke jpg, jpg ke png, konverter webp, konverter format gambar, konverter gambar online gratis',

        'tiff-to-jpg': 'tiff untuk dikonversi jpg, tiff to jpg, konverter gambar, konversi png ke jpg, jpg ke png, konverter webp, konverter format gambar, konverter gambar online gratis',

        'tiff-to-png': 'tiff untuk dikonversi png, tiff to png, konverter gambar, konversi png ke jpg, jpg ke png, konverter webp, konverter format gambar, konverter gambar online gratis',

        'jpg-to-gif': 'jpg untuk dikonversi gif, jpg to gif, konverter gambar, konversi png ke jpg, jpg ke png, konverter webp, konverter format gambar, konverter gambar online gratis',

        'png-to-gif': 'png untuk dikonversi gif, png to gif, konverter gambar, konversi png ke jpg, jpg ke png, konverter webp, konverter format gambar, konverter gambar online gratis',

        'jpg-to-bmp': 'jpg untuk dikonversi bmp, jpg to bmp, konverter gambar, konversi png ke jpg, jpg ke png, konverter webp, konverter format gambar, konverter gambar online gratis',

        'png-to-bmp': 'png untuk dikonversi bmp, png to bmp, konverter gambar, konversi png ke jpg, jpg ke png, konverter webp, konverter format gambar, konverter gambar online gratis',

        'webp-to-gif': 'webp untuk dikonversi gif, webp to gif, konverter gambar, konversi png ke jpg, jpg ke png, konverter webp, konverter format gambar, konverter gambar online gratis',

        'jpg-to-ico': 'jpg untuk dikonversi ico, jpg to ico, konverter gambar, konversi png ke jpg, jpg ke png, konverter webp, konverter format gambar, konverter gambar online gratis',

        'png-to-ico': 'png untuk dikonversi ico, png to ico, konverter gambar, konversi png ke jpg, jpg ke png, konverter webp, konverter format gambar, konverter gambar online gratis',

        'jpg-to-svg': 'jpg untuk dikonversi svg, jpg to svg, konverter gambar, konversi png ke jpg, jpg ke png, konverter webp, konverter format gambar, konverter gambar online gratis',

        'png-to-svg': 'png untuk dikonversi svg, png to svg, konverter gambar, konversi png ke jpg, jpg ke png, konverter webp, konverter format gambar, konverter gambar online gratis',

        'webp-to-svg': 'webp untuk dikonversi svg, webp to svg, konverter gambar, konversi png ke jpg, jpg ke png, konverter webp, konverter format gambar, konverter gambar online gratis',

        'gif-to-svg': 'gif untuk dikonversi svg, gif to svg, konverter gambar, konversi png ke jpg, jpg ke png, konverter webp, konverter format gambar, konverter gambar online gratis',

        'bmp-to-svg': 'bmp untuk dikonversi svg, bmp to svg, konverter gambar, konversi png ke jpg, jpg ke png, konverter webp, konverter format gambar, konverter gambar online gratis',

        'tiff-to-svg': 'tiff untuk dikonversi svg, tiff to svg, konverter gambar, konversi png ke jpg, jpg ke png, konverter webp, konverter format gambar, konverter gambar online gratis',

      },
    },
    title: 'Konverter Gambar',
    desc: 'Konversi gambar antara JPG, PNG, WEBP, GIF, SVG, TIFF, BMP dan lainnya. Konversi massal beberapa file sekaligus — cepat, privat, berjalan sepenuhnya di browser Anda.',
    toConvert: 'untuk dikonversi',
    convertSettings: 'Pengaturan Konversi',
    detected: 'Terdeteksi',
    convertTo: 'Konversi ke',
    converting: 'Mengonversi…',
    convertToFormat: 'Konversi ke {format}',
    popularConversions: 'Konversi Populer',
    convertingTo: 'Mengonversi ke',
    all: 'Semua',
  },
  resizer: {
    seo: {
      uploadTitle: 'Ubah Ukuran Gambar Online — Ubah Ukuran JPG, PNG, SVG, GIF Gratis | photremium.com',
      uploadDesc: 'Ubah ukuran gambar secara online gratis dengan piksel atau persentase. Ubah ukuran gambar JPG, PNG, SVG, dan GIF sambil menjaga kualitas. Tidak diperlukan pendaftaran.',
      uploadKeywords: 'ubah ukuran gambar, pengubah ukuran gambar, ubah ukuran jpg, ubah ukuran png, ubah dimensi gambar, ubah ukuran foto online gratis',
      workspaceTitle: 'Mengubah Ukuran Gambar — Pengubah Ukuran Gambar photremium.com',
      workspaceDesc: 'Ubah ukuran gambar secara online gratis dengan piksel atau persentase. Tidak diperlukan pendaftaran.',
      workspaceKeywords: 'ubah ukuran gambar, pengubah ukuran gambar, ubah ukuran jpg, ubah ukuran png',
    },
    title: 'Ubah Ukuran Gambar',
    desc: 'Tentukan dimensi Anda dengan piksel, persentase, sentimeter, atau inci dan ubah ukuran gambar JPG, PNG, SVG, dan GIF Anda secara instan. Ubah ukuran beberapa file sekaligus.',
    toResize: 'untuk diubah ukurannya',
    resizeSettings: 'Pengaturan Ukuran',
    resizeBy: 'Ubah ukuran berdasarkan:',
    byPixels: 'Berdasarkan Piksel',
    byPercentage: 'Berdasarkan Persentase',
    byCentimeters: 'Berdasarkan Sentimeter',
    byInches: 'Berdasarkan Inci',
    advanced: 'Lanjutan',
    lockAspect: 'Kunci rasio aspek',
    unlockAspect: 'Buka kunci rasio aspek',
    dontEnlarge: 'Jangan perbesar jika aslinya lebih kecil',
    resizing: 'Mengubah ukuran…',
    resizeDownload: 'Ubah Ukuran & Unduh',
    blog: {
      tocTitle: 'Daftar Isi',
      title: 'Blog Pengubah Ukuran Gambar',
      sections: [
        {
          id: 'imgresize-card-1',
          title: '1. Mengapa menggunakan pengubah ukuran gambar?',
          paragraphs: [
            'Pengubah ukuran gambar adalah alat atau perangkat lunak yang digunakan untuk mengubah dimensi gambar. Alat ini memungkinkan Anda menyesuaikan ukuran gambar yang diinginkan dengan mengubah tinggi, lebar, atau keduanya. Alat ini sangat berguna untuk platform media sosial yang memiliki batasan ukuran saat mengunggah atau memposting gambar.',
          ],
          listTitle: 'Contoh:',
          bullets: [
            'Postingan Instagram: 1080 x 1080px (Persegi)',
            'Postingan Facebook: 1200 x 630px',
            'Postingan X (dulu Twitter): 1200 x 675px',
            'Instagram Story: 1080 x 1920px',
          ],
        },
        {
          id: 'imgresize-card-2',
          title: '2. Mengapa memilih alat Pengubah Ukuran Gambar kami?',
          paragraphs: [
            'Pengubah ukuran gambar bertenaga AI kami membuat proses resize menjadi akurat dan sangat cepat. Anda dapat menggunakan alat ini dengan lancar di setiap perangkat. Tidak perlu memasang atau mengunduh aplikasi apa pun. Semua layanan tersedia secara online di browser pilihan Anda.',
          ],
          bullets: [
            'Anda dapat mengubah ukuran banyak gambar (bahkan 100+) sekaligus dengan alat kami. Jika Anda memiliki perangkat berperforma tinggi, Anda dapat dengan nyaman mengubah ukuran 400 hingga 500 gambar dalam hitungan detik.',
            'Semua pemrosesan dilakukan di browser lokal Anda. Anda tidak perlu mengunggah gambar ke server kami. Gambar Anda tidak pernah meninggalkan perangkat Anda. Jadi, Anda bisa mengubah ukuran gambar pribadi tanpa risiko privasi.',
            'Berbagai satuan didukung untuk pengubahan ukuran gambar.',
            'Anda juga dapat mempertahankan rasio aspek asli gambar setelah resize cukup dengan mencentang kotak opsi.',
            'Jika Anda mengubah ukuran banyak gambar, Anda bisa mengunduh hasilnya sebagai file terpisah atau sebagai file ZIP.',
          ],
        },
        {
          id: 'imgresize-card-3',
          title: '3. Panduan langkah demi langkah',
          steps: [
            {
              heading: 'Pertama, pilih gambar atau beberapa gambar yang ingin Anda ubah ukurannya. Ada beberapa cara untuk memilih gambar.',
              bullets: [
                'Anda bisa langsung drag and drop gambar untuk mengubah ukurannya.',
                'Shortcut “Ctrl + V” juga didukung untuk menempelkan gambar ke kotak drop.',
                'Klik tombol “Choose Files” untuk membuka file explorer. Anda juga bisa memilih gambar yang diinginkan dari sana.',
              ],
            },
            {
              heading: 'Kemudian, Anda dapat memilih salah satu satuan untuk resize gambar. Saat ini kami menyediakan satuan berikut:',
              bullets: ['Pixels', 'Percentage', 'Centimeters', 'Inches'],
            },
            {
              heading: 'Setelah memilih satuan, atur tinggi dan lebar untuk mengubah ukuran gambar. Anda juga bisa mengunci rasio aspek dengan mencentang kotak.',
            },
            {
              heading: 'Lalu centang “Don’t enlarge if original is smaller” jika Anda tidak ingin gambar hasil resize diperbesar melebihi ukuran aslinya.',
            },
            {
              heading: 'Setelah itu, pilih opsi unduhan.',
              bullets: [
                'Pilih ZIP jika Anda ingin mengubah ukuran banyak gambar dan mengunduh semuanya sebagai satu file zip.',
                'Atau pilih “separate” untuk mengunduh setiap gambar hasil resize secara terpisah.',
              ],
            },
            {
              heading: 'Kemudian tekan tombol “Resize & Download” untuk mengunduh gambar hasil resize sesuai opsi unduhan yang Anda pilih.',
            },
          ],
        },
        {
          id: 'imgresize-card-4',
          title: '4. Manfaat alat pengubah ukuran gambar: Manfaat paling menonjol dari alat ini adalah penempatan gambar yang tepat di halaman web dan posting media sosial.',
          tocLabel: '4. Manfaat alat pengubah ukuran gambar',
          bullets: [
            'Meningkatkan UX: Ukuran yang tepat dan penempatan gambar yang benar sangat meningkatkan pengalaman pengguna. Menempatkan gambar terlalu besar atau terlalu kecil tanpa penyesuaian akan menghasilkan UX yang buruk.',
            'Dukungan Media Sosial: Banyak aplikasi media sosial memiliki batas dimensi sendiri untuk posting gambar. Alat kami membantu Anda menyesuaikan gambar ke dimensi yang dibutuhkan tersebut.',
            'Desain Responsif: Jika Anda seorang developer dan ingin membuat desain responsif, Anda harus mengubah ukuran gambar dalam berbagai dimensi untuk mendukung banyak perangkat.',
            'Pilihan Terbaik: Daripada meregangkan atau memotong gambar yang dapat mengubah proporsi dimensinya, pengubah ukuran adalah pilihan terbaik.',
          ],
        },
        {
          id: 'imgresize-card-5',
          title: '5. Format yang didukung: Alat pengubah ukuran gambar kami memungkinkan Anda memilih gambar dalam format apa pun untuk diubah ukurannya. Berikut formatnya:',
          tocLabel: '5. Format yang didukung',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },
  cropper: {
    seo: {
      uploadTitle: 'Potong Gambar Online — Potong JPG, PNG, GIF Gratis | photremium.com',
      uploadDesc: 'Potong gambar JPG, PNG, dan GIF secara online dengan mudah. Pilih piksel untuk menentukan area potong atau gunakan editor visual kami. Gratis, cepat, dan privat.',
      uploadKeywords: 'potong gambar, pemotong gambar, potong jpg, potong png, potong foto online gratis, alat potong gambar',
      workspaceTitle: 'Memotong Gambar — Pemotong Gambar photremium.com',
      workspaceDesc: 'Potong gambar secara online gratis. Editor potong visual dengan rasio preset. Tidak diperlukan pendaftaran.',
      workspaceKeywords: 'potong gambar, pemotong gambar, potong jpg, potong png',
    },
    title: 'Potong Gambar',
    desc: 'Potong JPG, PNG, GIF & lainnya dengan editor visual kami. Pilih dari rasio preset atau potong bebas. Berjalan sepenuhnya di browser Anda.',
    toCrop: 'untuk dipotong',
    cropSettings: 'Pengaturan Potong',
    widthPx: 'Lebar (px)',
    heightPx: 'Tinggi (px)',
    positionX: 'Posisi X (px)',
    positionY: 'Posisi Y (px)',
    cropTemplate: 'Template Potong',
    landscape: 'Lanskap',
    portrait: 'Potret',
    square: 'Persegi',
    freeform: 'Bebas',
    cropping: 'Memotong…',
    cropDownload: 'Potong & Unduh',
    cropDownloadAll: 'Potong & Unduh Semua',
    saveNext: 'Simpan & Lanjut',
    croppedNofTotal: 'Anda telah memotong {n} dari {total} gambar.',
    downloadN: 'Unduh {n}',
    blog: {
      tocTitle: 'Daftar Isi',
      title: 'Blog Pemotong Gambar',
      sections: [
        {
          id: 'imgcrop-card-1',
          title: '1. Mengapa menggunakan pemotong gambar?',
          paragraphs: [
            'Pemotong gambar adalah alat perangkat lunak yang digunakan untuk memotong gambar ke bentuk yang diinginkan. Alat ini banyak digunakan untuk memotong bagian gambar yang diperlukan dan menghapus bagian luar yang tidak diinginkan untuk tujuan apa pun. Alat ini menyediakan kotak potong yang dapat Anda sesuaikan pada posisi yang ingin Anda potong.',
          ],
          listTitle: 'Sebagai Contoh:',
          bullets: [
            'Memotong gambar Anda sendiri dari foto grup.',
            'Memotong nama Anda dari daftar.',
            'Memotong bilah progres dari cuplikan layar penuh.',
          ],
        },
        {
          id: 'imgcrop-card-2',
          title: '2. Mengapa memilih pemotong gambar kami?',
          paragraphs: [
            'Alat pemotong gambar kami memungkinkan Anda memotong gambar dengan akurat dan sangat cepat. Anda hanya perlu menyesuaikan ukuran kotak potong pada posisi yang ingin Anda potong dari gambar apa pun. Hampir semua format gambar didukung untuk pemilihan gambar.',
          ],
          bullets: [
            'Anda dapat memotong sebanyak jumlah gambar yang didukung perangkat Anda. Jika Anda memiliki perangkat dengan performa terbaik, Anda bahkan dapat memotong 100+ gambar sekaligus tanpa lag atau masalah lainnya.',
            'Gambar Anda akan diproses di browser lokal Anda. Tidak perlu mengunggah gambar apa pun ke server kami, sehingga tidak ada gambar yang meninggalkan perangkat Anda. Anda dapat memotong gambar pribadi Anda tanpa ketidakamanan atau risiko.',
            'Banyak alat menandai kesalahan format gambar tidak valid. Alat pemotong gambar kami menangani masalah ini dengan mendukung hampir semua format gambar.',
            'Jika Anda memotong banyak gambar sekaligus, alat kami memungkinkan Anda mengunduh gambar yang sudah dipotong sebagai ZIP atau sebagai gambar terpisah sesuai preferensi Anda.',
          ],
        },
        {
          id: 'imgcrop-card-3',
          title: '3. Panduan langkah demi langkah',
          steps: [
            {
              heading: '1. Pertama-tama, pilih gambar yang ingin Anda potong. Pemilihan beberapa gambar sekaligus juga didukung oleh alat pemotong gambar kami.',
              bullets: [
                'Seret dan lepas gambar ke kotak drop untuk memotongnya.',
                'Anda juga dapat memilih gambar melalui penjelajah file dengan mengklik tombol choose files yang ditempatkan di kotak potong.',
                'Shortcut Ctrl + V juga didukung untuk menempelkan gambar ke kotak drop.',
              ],
            },
            {
              heading: '2. Kemudian, sesuaikan ukuran dan posisi kotak potong pada gambar untuk memotongnya.',
            },
            {
              heading: '3. Anda juga dapat menyesuaikan kotak potong dengan memasukkan nilai tinggi, lebar, posisi horizontal, dan posisi vertikal secara manual.',
            },
            {
              heading: '4. Anda juga dapat menggunakan beberapa template siap pakai:',
              bullets: [
                'Landscape(16:9)',
                'Portrait(9:16)',
                'Square(1:1)',
              ],
            },
            {
              heading: '5. Kemudian Anda harus memilih salah satu opsi unduhan.',
              bullets: [
                'ZIP: Pilih opsi ini jika Anda memotong banyak gambar dan ingin mengunduh semua gambar yang sudah dipotong sebagai satu file.',
                'Separate: Jika Anda ingin mengunduh semua gambar yang sudah dipotong secara terpisah, maka pilih opsi ini dari tombol toggle.',
              ],
            },
            {
              heading: '6. Kemudian klik tombol Crop & Download untuk mengunduh semua gambar Anda yang sudah dipotong sesuai dimensi preset Anda.',
            },
          ],
        },
        {
          id: 'imgcrop-card-4',
          title: '4. Manfaat Pemotong Gambar: Alat pemotong gambar menawarkan beberapa manfaat di dunia digital. Beberapa dijelaskan di bawah ini:',
          tocLabel: '4. Manfaat Pemotong Gambar',
          bullets: [
            'Menyesuaikan gambar dalam frame: Pemotong gambar membantu Anda menempatkan gambar dengan benar dalam frame. Frame ini bisa berada di halaman web atau di platform media sosial apa pun.',
            'Meningkatkan UX: Karena penempatan gambar yang tepat meningkatkan pengalaman pengguna, pemotong gambar membantu meningkatkan UX secara besar.',
            'Menghapus batas yang tidak diinginkan: Anda dapat menghapus batas yang tidak diinginkan dari gambar untuk menyempurnakannya.',
            'Memisahkan objek yang diinginkan: Anda juga dapat memisahkan gambar Anda dari foto grup.',
            'Menghemat Penyimpanan: Memotong gambar pasti menghemat penyimpanan karena area mentah gambar dipotong dan hanya bagian yang diinginkan yang disimpan.',
            'Mengoptimalkan Presentasi: Karena presentasi normal dengan 10 gambar yang belum dipotong memakan hampir 30MB penyimpanan, presentasi yang sama dengan gambar yang dipotong dapat memakan hampir 10MB penyimpanan.',
          ],
        },
        {
          id: 'imgcrop-card-5',
          title: '5. Format yang didukung:',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },
  photoEditor: {
    seo: {
      title: 'Editor Foto Online — Edit Gambar Gratis dengan Teks, Efek & Bingkai | photremium.com',
      desc: 'Edit foto secara online gratis — tambahkan teks, efek, bingkai, stiker, dan lainnya. Alat pengeditan gambar yang sederhana namun powerful langsung di browser Anda.',
      keywords: 'editor foto, editor foto online, edit foto online gratis, tambah teks ke gambar, efek gambar, bingkai foto',
    },
    title: 'Editor Foto',
    desc: 'Perindah gambar Anda dengan teks, efek, bingkai, dan stiker. Alat pengeditan sederhana untuk semua kebutuhan gambar Anda.',
    toEdit: 'untuk diedit',
    textTypography: 'Teks & Tipografi',
    textTypographyDesc: 'Tambahkan teks khusus dengan berbagai font, warna, bayangan, dan opsi penempatan.',
    filtersEffects: 'Filter & Efek',
    filtersEffectsDesc: 'Terapkan filter profesional, sesuaikan kecerahan, kontras, saturasi, dan lainnya.',
    framesStickers: 'Bingkai & Stiker',
    framesStickersDesc: 'Pilih dari bingkai indah dan stiker lucu untuk mempercantik gambar Anda.',
  },
  removeBg: {
    seo: {
      uploadTitle: 'Hapus Latar Belakang Gambar Online Gratis | photremium.com',
      uploadDesc: 'Hapus latar belakang gambar dengan akurasi tinggi secara cepat. Penghapus latar belakang online gratis — berjalan sepenuhnya di browser Anda.',
      uploadKeywords: 'hapus latar belakang, penghapus latar belakang, hapus latar belakang gambar, latar belakang transparan, potong latar belakang gratis',
      workspaceTitle: 'Menghapus Latar Belakang — Penghapus Latar Belakang photremium.com',
      workspaceDesc: 'Hapus latar belakang gambar secara online gratis. Tidak diperlukan pendaftaran.',
      workspaceKeywords: 'hapus latar belakang, penghapus latar belakang, latar belakang transparan',
    },
    title: 'Hapus Latar Belakang',
    desc: 'Hapus latar belakang dari gambar Anda secara instan dengan deteksi tepi canggih. 100% gratis, berjalan sepenuhnya di browser Anda — tanpa upload, tanpa server.',
    toRemoveBg: 'untuk menghapus latar belakang',
    backgroundRemover: 'Penghapus Latar Belakang',
    processingProgress: 'Kemajuan Pemrosesan',
    processingNImages: 'Memproses {n} gambar…',
    allNProcessed: 'Semua {n} gambar telah diproses!',
    nOfTotalDone: '{n} / {total} selesai',
    fileName: 'Nama File',
    dimensions: 'Dimensi',
    status: 'Status',
    statusDone: '✓ Selesai',
    statusProcessing: '⏳ Memproses',
    statusError: '✗ Kesalahan',
    statusPending: '⏸ Tertunda',
    badgeDone: 'Selesai',
    badgeProcessing: 'Memproses…',
    badgeError: 'Kesalahan',
    removingBg: 'Menghapus latar belakang…',
    retry: 'Coba Lagi',
    downloading: 'Mengunduh…',
    nextImage: 'Gambar Berikutnya',
  },
  watermark: {
    seo: {
      uploadTitle: 'Tanda Air Gambar Online — Tambah Tanda Air Teks & Logo Gratis | photremium.com',
      uploadDesc: 'Tambahkan tanda air teks atau gambar ke foto Anda dalam hitungan detik. Gratis, cepat, dan privat.',
      uploadKeywords: 'tanda air gambar, tambah tanda air, tanda air teks, tanda air logo, alat tanda air gambar gratis',
      workspaceTitle: 'Menambahkan Tanda Air — Alat Tanda Air photremium.com',
      workspaceDesc: 'Tambahkan tanda air ke gambar secara online gratis. Tidak diperlukan pendaftaran.',
      workspaceKeywords: 'tanda air gambar, tambah tanda air, tanda air teks, tanda air logo',
    },
    title: 'Tanda Air Gambar',
    desc: 'Tambahkan tanda air teks atau logo ke gambar Anda. Sesuaikan font, opasitas, ukuran, posisi, dan lainnya. Berjalan sepenuhnya di browser Anda.',
    toWatermark: 'untuk ditandai air',
    watermarkTools: 'Alat Tanda Air',
    addText: 'Tambah Teks',
    addImage: 'Tambah Gambar',
    layersN: 'Layer ({n})',
    noLayers: 'Belum ada layer yang ditambahkan',
    textLayer: 'Layer Teks',
    imageLayer: 'Layer Gambar',
    watermarkDownloadAll: 'Tanda Air & Unduh Semua',
    watermarkDownload: 'Tanda Air & Unduh',
    nextImage: 'Gambar Berikutnya',
    privateMode: 'Mode Privat',
    privateModeOn: 'Mode Privat AKTIF: Hanya pindahkan dan ubah ukuran tanda air pada gambar ini…',
    privateModeHint: 'Aktifkan Mode Privat untuk menyesuaikan hanya posisi dan ukuran…',
    privateModeActive: 'Mode Privat — hanya pindahkan, ubah ukuran, dan ubah ukuran font yang diizinkan',
    selectToEdit: 'Pilih gambar atau teks apa pun untuk mulai mengedit',
    bold: 'Tebal',
    italic: 'Miring',
    underline: 'Garis Bawah',
    bgColor: 'Warna Latar Belakang',
    textColor: 'Warna Teks',
    alignLeft: 'Rata Kiri',
    alignCenter: 'Rata Tengah',
    alignRight: 'Rata Kanan',
    opacity: 'Opasitas',
    stroke: 'Garis',
    strokeWidth: 'Lebar Garis',
    strokeColor: 'Warna Garis',
    tileRepeat: 'Ubin / Ulangi',
    tilePattern: 'Pola Ubin',
    spacing: 'Jarak',
    snapToCenter: 'Snap ke Tengah',
    duplicate: 'Duplikat',
    delete: 'Hapus',
    flipHorizontal: 'Balik Horizontal',
    flipVertical: 'Balik Vertikal',
    rotateLeft: 'Putar Kiri',
    rotateRight: 'Putar Kanan',
    cornerRadius: 'Radius Sudut',
    borderStroke: 'Batas / Garis',
    borderWidth: 'Lebar Batas',
    color: 'Warna',
    style: 'Gaya',
    hide: 'Sembunyikan',
    show: 'Tampilkan',
    lock: 'Kunci',
    unlock: 'Buka Kunci',
    solid: 'Solid',
    dashed: 'Putus-putus',
    dotted: 'Bertitik',
    double: 'Ganda',
    tileSingle: 'Tunggal',
    tile2x2: 'Grid 2×2',
    tile3x3: 'Grid 3×3',
    removeAllConfirm: 'Hapus semua gambar dan tanda air?',
    dimMismatch: 'Gambar yang Anda unggah memiliki dimensi berbeda. Coba unggah gambar dengan resolusi yang sama untuk hasil terbaik, atau terapkan tanda air satu per satu.',
    clearBackground: 'Hapus Latar Belakang',
    typeHere: 'Ketik di sini...',
    linkCorners: 'Hubungkan sudut',
    separateCorners: 'Pisahkan sudut',
    blog: {
      tocTitle: 'Daftar Isi',
      sections: [
        {
          id: 'wm-blog-intro',
          tocLabel: 'Ringkasan Alat Tanda Air',
          title: 'Cara Menambahkan Tanda Air ke Gambar Secara Online — Panduan Lengkap Alat Tanda Air Photremium',
          paragraphs: [
            'Anda baru saja selesai mengedit foto yang indah. Mungkin itu foto produk untuk toko Anda, potret dari sesi klien, atau karya seni digital yang Anda sempurnakan berjam-jam. Dan sekarang muncul pertanyaan yang pada akhirnya dihadapi setiap kreator: bagaimana melindunginya sebelum dibagikan?',
            'Jawaban yang dipilih sebagian besar profesional adalah tanda air — dan itu masuk akal. Tanda air yang ditempatkan dengan tepat bertindak sebagai tanda tangan permanen, membuat karya Anda dapat dilacak, berlabel, dan jauh lebih sulit untuk dicuri.',
            'Masalah yang sering dihadapi adalah: alat online yang tersedia terlalu rumit, terkunci di balik langganan, atau menghasilkan tanda air yang terlalu berat sehingga merusak gambar.',
            'Alat Tanda Air Gambar Photremium dibuat untuk memperbaiki semua itu. Ini adalah ruang kerja pemberian tanda air berbasis browser sepenuhnya, gratis, tanpa akun, dan berjalan langsung di browser Anda tanpa pernah mengunggah file ke server. Semuanya tetap lokal, semuanya tetap cepat, dan tingkat kontrol kreatifnya setara dengan aplikasi desktop. Dalam panduan ini, kami akan menjelaskan cara kerjanya, siapa yang cocok menggunakannya, dan bagaimana mendapatkan hasil terbaik — setiap saat.',
          ],
        },
        {
          id: 'wm-blog-what-is',
          tocLabel: 'Apa Itu Tanda Air',
          title: 'Apa Itu Tanda Air dan Mengapa Penting?',
          paragraphs: [
            'Sebelum masuk ke alatnya, penting untuk memahami apa fungsi tanda air dan mengapa begitu banyak fotografer, desainer, dan kreator konten menganggapnya wajib.',
            'Tanda air adalah overlay yang terlihat pada gambar — biasanya teks, logo, atau simbol hak cipta — yang mengidentifikasi pembuat atau pemilik konten. Berbeda dari metadata (yang tersembunyi di dalam file dan bisa dihapus dalam hitungan detik), tanda air tertanam secara visual pada gambar. Anda tidak bisa sekadar klik kanan dan menghapusnya tanpa menurunkan kualitas gambar secara nyata.',
          ],
          subSections: [
            {
              title: 'Mengapa Kreator Menggunakan Tanda Air',
              paragraphs: [
                'Alasan praktis untuk memberi tanda air pada gambar umumnya bermuara pada tiga hal utama.',
              ],
              bullets: [
                'Identifikasi kepemilikan. Ketika karya Anda dibagikan di media sosial, papan Pinterest, atau disematkan di blog, atribusi asli sering hilang. Tanda air memastikan nama atau merek Anda tetap menyertai gambar ke mana pun ia tersebar.',
                'Pencegahan pencurian. Banyak pencuri gambar kasual mencari jalan termudah. Tanda air yang terlihat profesional, ditempatkan dengan baik dan sedikit transparan, mengirim sinyal yang jelas: gambar ini milik seseorang yang menjaga karyanya.',
                'Perlindungan portofolio klien. Fotografer yang membagikan pratinjau sebelum pembayaran akhir sering memakai tanda air agar klien tidak menggunakan pratinjau tanpa melunasi pembayaran. Tanda air yang halus melindungi tanpa mengganggu penilaian karya.',
              ],
            },
            {
              title: 'Siapa yang Perlu Memberi Tanda Air pada Gambar',
              paragraphs: [
                'Jika Anda termasuk salah satu kategori berikut, memberi tanda air sebelum membagikan gambar secara online bukanlah pilihan — itu penting:',
              ],
              bullets: [
                'Fotografer lepas yang membagikan galeri kepada klien',
                'Desainer grafis yang mendistribusikan sampel portofolio',
                'Penjual e-commerce yang menampilkan foto produk sebelum perjanjian lisensi',
                'Seniman digital yang membagikan karya di platform sosial',
                'Blogger dan kreator konten yang gambarnya sering digunakan ulang',
                'Kontributor foto stok yang membangun merek yang mudah dikenali',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-workspace',
          tocLabel: 'Panel Ruang Kerja',
          title: 'Di Dalam Alat Tanda Air Photremium: Ruang Kerja Tiga Panel untuk Alur Kerja Nyata',
          paragraphs: [
            'Yang membedakan alat tanda air Photremium dari watermark online dasar adalah desain ruang kerjanya. Alih-alih sekadar “ketik teks, pilih posisi, selesai”, alat ini menyediakan tata letak tiga panel yang meniru software desain profesional — tetapi berjalan sepenuhnya di browser, tanpa instalasi.',
          ],
          subSections: [
            {
              title: 'Panel Kanvas di Kiri',
              paragraphs: [
                'Panel kanvas mengambil area terbesar di layar dan menunjukkan seperti apa gambar Anda dengan tanda air secara real-time. Setiap perubahan — mengatur opasitas, memindahkan lapisan teks, mengubah ukuran logo — langsung terlihat di kanvas. Tidak ada tombol “preview”. Apa yang Anda lihat adalah hasilnya.',
                'Kanvas juga memiliki toolbar zoom bawaan, sehingga Anda dapat zoom in untuk presisi dan zoom out untuk melihat keseluruhan. Fitur zoom-to-fit secara otomatis menghitung skala awal terbaik berdasarkan ukuran layar, sehingga gambar beresolusi tinggi tetap nyaman untuk dikerjakan. Panduan alignment muncul secara dinamis saat Anda menyeret lapisan mendekati pusat horizontal atau vertikal, dan membuat tanda air terkunci tepat di tengah dengan presisi yang biasanya hanya Anda dapatkan di Photoshop.',
              ],
            },
            {
              title: 'Panel Pengaturan di Kanan',
              paragraphs: [
                'Panel kanan adalah pusat kontrol. Di sinilah Anda mengelola lapisan tanda air, menyesuaikan tampilannya, dan menjalankan ekspor akhir. Di desktop, panel ini tetap di sisi kanan layar. Di perangkat mobile, panel ini muncul sebagai bottom sheet yang digerakkan tombol roda gigi mengambang, sehingga tidak menutupi kanvas saat Anda bekerja.',
                'Di panel kanan terdapat pengelola lapisan, yang menampilkan semua elemen tanda air yang Anda tambahkan. Setiap entri lapisan menampilkan tipe (teks atau gambar), nama/konten, dan tiga tombol aksi cepat: toggle visibilitas (ikon mata), toggle kunci untuk mengunci posisi lapisan, dan tombol hapus.',
              ],
            },
            {
              title: 'Strip Pratinjau di Kiri (Mode Multi-Gambar)',
              paragraphs: [
                'Saat Anda bekerja dengan banyak gambar sekaligus — misalnya batch foto produk atau sesi potret penuh — sebuah strip thumbnail vertikal muncul di sisi kiri layar. Ini adalah antrean gambar, yang menampilkan pratinjau mini dari setiap file yang Anda muat. Klik salah satu thumbnail untuk langsung beralih ke gambar itu di kanvas, sehingga Anda dapat memeriksa tampilan tanda air pada komposisi yang berbeda tanpa kehilangan pengaturan lapisan.',
                'Strip ini juga menampilkan ukuran file dalam KB atau MB serta format file (JPG, PNG, WEBP), sehingga Anda selalu tahu apa yang sedang Anda kerjakan sekilas.',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-steps',
          tocLabel: 'Langkah demi Langkah',
          title: 'Langkah demi Langkah: Cara Menambahkan Tanda Air di Photremium',
          paragraphs: [
            'Panduan ini didasarkan langsung pada cara kerja alat di balik layar — dari sistem upload drag-and-drop hingga mesin rendering kanvas yang menuliskan tanda air secara permanen ke gambar sebelum diunduh.',
          ],
          steps: [
            {
              heading: 'Langkah 1 — Unggah Gambar Anda',
              paragraphsBefore: [
                'Buka photremium.com/watermark-image. Anda akan masuk ke layar upload dengan area dropzone di tengah halaman.',
                'Ada tiga cara untuk memasukkan gambar ke alat ini:',
              ],
              bullets: [
                'Drag and drop. Seret satu atau beberapa file gambar dari desktop langsung ke dropzone. Alat ini menerima format gambar standar — JPEG, PNG, WEBP, dan lainnya. Saat Anda menyeret file ke area kerja, batas ungu muncul di seluruh area dengan pesan “Drop images to add for watermarking”, menandakan drop terdeteksi.',
                'Click to browse. Klik tombol “Choose Files” di dalam dropzone untuk membuka pemilih file. Anda dapat memilih beberapa file sekaligus menggunakan Ctrl+Click (Windows) atau Cmd+Click (Mac).',
                'Paste from clipboard. Jika Anda menyalin gambar ke clipboard — dari tangkapan layar, aplikasi lain, atau browser — cukup tekan Ctrl+V (atau Cmd+V di Mac) pada halaman watermark dan gambar akan dimuat langsung ke ruang kerja. Ini tetap berfungsi meski beberapa gambar sudah dimuat sebelumnya.',
              ],
              paragraphsAfter: [
                'Begitu gambar pertama dimuat, ruang kerja beralih dari layar upload ke editor tiga panel penuh, dan kanvas menampilkan gambar Anda pada level zoom fit-to-screen yang dihitung otomatis.',
              ],
            },
            {
              heading: 'Langkah 2 — Tambahkan Lapisan Teks Tanda Air',
              paragraphsBefore: [
                'Klik tombol ungu “Add Text” di panel kanan. Sebuah lapisan teks baru muncul di kanvas dengan placeholder “Type here...” yang sudah terpilih.',
                'Anda dapat langsung mengetik. Teks dirender secara live di kanvas dalam Arial putih dengan ukuran default yang disesuaikan dengan dimensi gambar. Dari toolbar atas yang muncul saat lapisan teks dipilih, Anda dapat menyesuaikan semua aspek teks:',
              ],
              bullets: [
                'Font family — pilih dari 12 font bawaan termasuk Arial, Georgia, Impact, Brush Script MT, Comic Sans MS, dan lainnya',
                'Font size — ketik nilai piksel khusus atau gunakan kontrol naik/turun',
                'Bold, italic, underline — aktifkan kombinasi gaya apa pun',
                'Text color — klik swatch warna untuk membuka pemilih warna dan memilih warna hex apa pun',
                'Background color — tambahkan latar belakang berwarna untuk tampilan label atau badge',
                'Stroke (outline) — atur lebar dan warna garis untuk keterbacaan maksimum di gambar terang maupun gelap',
                'Opacity — geser dari 0% (tak terlihat) hingga 100% (sepenuhnya terlihat); kebanyakan tanda air berada di 30–60%',
                'Alignment — rata kiri, tengah, atau kanan di dalam bounding box',
                'Rotation — putar lapisan teks ke sudut mana pun dengan titik snap magnetik di 0°, 90°, 180°, dan 270° untuk penempatan cepat',
              ],
              paragraphsAfter: [
                'Untuk memindahkan teks, klik dan seret ke mana saja di kanvas. Untuk penempatan presisi piksel, gunakan tombol panah pada keyboard (tahan Shift untuk langkah 10 piksel). Untuk mengubah ukuran kotak teks, seret salah satu dari delapan handle (sudut dan sisi) yang muncul di sekitar lapisan yang dipilih.',
              ],
            },
            {
              heading: 'Langkah 3 — Tambahkan Lapisan Tanda Air Gambar (Logo)',
              paragraphsBefore: [
                'Jika Anda ingin menggunakan logo, tanda tangan, atau gambar sebagai tanda air, klik tombol biru “Add Image” di panel kanan. Pemilih file akan terbuka sehingga Anda dapat memilih gambar tanda air dari perangkat Anda.',
                'Alat ini otomatis mengatur ukuran gambar tanda air sekitar 30% dari lebar kanvas dengan mempertahankan rasio aspek aslinya, dan memusatkannya di kanvas. Setelah itu, Anda dapat menyeretnya ke posisi mana pun, mengubah ukurannya dengan handle sudut (rasio aspek tetap), atau memutarnya dengan handle rotasi khusus yang muncul di atas lapisan yang dipilih.',
                'Untuk lapisan tanda air tipe gambar, panel kanan menampilkan kontrol tambahan:',
              ],
              bullets: [
                'Opacity — sama seperti lapisan teks, ideal untuk logo PNG transparan',
                'Flip horizontal / Flip vertical — cerminkan tanda air jika diperlukan',
                'Border width, border color, and border style — tambahkan border yang terlihat di sekitar logo tanda air',
                'Border radius — bulatkan sudut logo tanda air, baik seragam maupun per sudut',
                'Rotation — perilaku rotasi halus yang sama seperti lapisan teks',
              ],
            },
            {
              heading: 'Langkah 4 — Atur Tiling (Opsional)',
              paragraphsBefore: [
                'Salah satu fitur yang lebih kuat adalah tiling — kemampuan untuk mengulang tanda air di seluruh gambar dalam pola grid. Ini sangat berguna jika Anda ingin membuat gambar sulit digunakan ulang, bukan sekadar memberi label.',
                'Dengan lapisan yang dipilih, cari opsi tile di toolbar. Anda dapat mengaturnya menjadi:',
              ],
              bullets: [
                'None — penempatan tunggal (default)',
                'Grid 2×2 — mengulang tanda air dalam pola 2 kolom, 2 baris',
                'Grid 3×3 — mengulang dalam grid 3×3 untuk cakupan lebih rapat',
              ],
              paragraphsAfter: [
                'Anda juga dapat mengatur jarak antar tile, yang mengontrol jarak antar setiap pengulangan. Kanvas menampilkan pratinjau bayangan dari semua salinan tile sehingga Anda bisa melihat pola cakupan penuh sebelum mengunduh.',
              ],
            },
            {
              heading: 'Langkah 5 — Gunakan Pengelola Lapisan untuk Banyak Tanda Air',
              paragraphsBefore: [
                'Anda dapat menambahkan sebanyak mungkin lapisan — mencampur tanda air teks dan gambar. Pengelola lapisan di panel kanan menampilkan semuanya. Anda dapat:',
              ],
              bullets: [
                'Menampilkan/menyembunyikan lapisan dengan ikon mata — berguna untuk beralih antar versi tanda air tanpa menghapus apa pun',
                'Mengunci lapisan untuk mencegah pergeseran saat mengerjakan lapisan lain',
                'Menghapus lapisan secara permanen',
              ],
              paragraphsAfter: [
                'Klik salah satu entri lapisan di daftar akan memilihnya di kanvas secara bersamaan, sehingga Anda dapat berpindah antar lapisan dengan mudah tanpa mencari-cari di gambar.',
              ],
            },
            {
              heading: 'Langkah 6 — Berpindah di Antara Banyak Gambar',
              paragraphsBefore: [
                'Jika Anda mengunggah lebih dari satu gambar, gunakan strip thumbnail di kiri untuk beralih gambar aktif. Lapisan tanda air yang Anda atur berlaku secara universal — semuanya akan dirender pada setiap gambar saat diekspor.',
                'Alat ini juga memeriksa konsistensi resolusi pada batch Anda. Jika gambar memiliki dimensi yang sangat berbeda (lebih dari 5% perbedaan lebar atau tinggi), muncul peringatan bahwa posisi tanda air bisa terlihat berbeda karena variasi ukuran. Mesin menanganinya dengan algoritme pemposisian ulang proporsional: posisi tanda air dihitung sebagai persentase dari dimensi gambar referensi dan diterapkan secara proporsional ke setiap gambar lainnya, sehingga menjaga niat visual bahkan di resolusi yang berbeda.',
              ],
            },
            {
              heading: 'Langkah 7 — Atur Preferensi Unduhan',
              paragraphsBefore: [
                'Untuk pekerjaan satu gambar, klik tombol “Download” di bawah kanvas untuk menyimpan gambar bertanda air secara langsung. Nama file otomatis menggunakan nama asli dengan tambahan “-watermarked” sebelum ekstensi. Gambar JPEG diekspor pada kualitas 0.95 — cukup tinggi sehingga sulit dibedakan dari aslinya pada ukuran tampilan normal. Gambar PNG diekspor sebagai PNG tanpa kehilangan kualitas.',
                'Untuk pekerjaan batch (banyak gambar), tersedia dua mode unduhan di panel kanan:',
              ],
              bullets: [
                'ZIP file — semua gambar bertanda air dikemas ke dalam satu arsip ZIP dan diunduh dengan satu klik. Alat ini memuat JSZip secara dinamis untuk kompresi.',
                'Separate files — setiap gambar diunduh sebagai file terpisah dengan jeda singkat antar unduhan untuk mencegah throttling browser.',
              ],
            },
            {
              heading: 'Langkah 8 — Unduh dan Verifikasi',
              paragraphsBefore: [
                'Setelah Anda menekan tombol unduh (atau tombol “Watermark & Download All” untuk batch), alat ini merender setiap gambar pada elemen canvas HTML5 tersembunyi dengan resolusi asli penuh — bukan pada ukuran pratinjau yang tampak di layar. Ini berarti gambar yang diekspor berada pada 100% dimensi piksel aslinya dengan tanda air pada ukuran proporsional yang benar. Buka file yang diunduh dan zoom untuk memverifikasi bahwa penempatan dan kualitas tanda air sesuai harapan Anda.',
                'Jika ada yang kurang tepat, cukup kembali ke ruang kerja — lapisan Anda masih ada — sesuaikan, lalu unduh kembali.',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-tips',
          tocLabel: 'Tips Pro',
          title: 'Tips Pro untuk Hasil Terbaik',
          bullets: [
            'Gunakan logo PNG semi-transparan untuk kesan profesional maksimal. Tanda air logo dengan latar transparan pada opasitas 40–50% terlihat jauh lebih rapi dibanding teks solid. Ekspor logo Anda dari alat desain sebagai PNG dengan alpha transparency sebelum digunakan sebagai lapisan gambar.',
            'Tempatkan tanda air di area yang jika dipotong akan mengurangi nilai. Sudut kanan bawah adalah penempatan paling umum — dan paling mudah dipotong. Untuk perlindungan lebih kuat, pertimbangkan menempatkan tanda air di area visual penting seperti wajah, detail produk, atau titik fokus. Opsi tile diagonal jauh lebih sulit dihapus tanpa merusak gambar.',
            'Gunakan fitur kunci saat bekerja dengan banyak lapisan. Setelah posisi tanda air utama Anda pas, kunci lapisan itu sebelum menambahkan lapisan sekunder. Ini mencegah pergeseran yang tidak disengaja.',
            'Uji di area terang dan gelap. Tanda air putih tidak terlihat di langit cerah namun terbaca di bayangan gelap. Tambahkan garis tipis atau warna latar agar keterbacaan terjaga apa pun konten di bawahnya.',
            'Shortcut keyboard selalu menghemat waktu. Tombol panah memindahkan lapisan terpilih satu piksel per langkah. Shift+Arrow memindahkan sepuluh piksel per langkah. Tombol Delete menghapus lapisan terpilih secara instan. Ini membuat penyetelan posisi jauh lebih cepat dibanding menyeret.',
          ],
        },
        {
          id: 'wm-blog-privacy',
          tocLabel: 'Privasi dan Keamanan',
          title: 'Privasi dan Keamanan: Mengapa Pemrosesan Berbasis Browser Itu Penting',
          paragraphs: [
            'Salah satu kekhawatiran yang sering dimiliki kreator saat menggunakan alat online adalah: ke mana sebenarnya gambar mereka pergi? Dengan alat tanda air berbasis server, gambar Anda diunggah ke server penyedia, diproses di sana, lalu dikirim kembali kepada Anda. Itu berarti karya yang belum dipublikasikan, foto klien, atau gambar produk sensitif melewati infrastruktur pihak lain.',
            'Alat tanda air Photremium memproses semuanya secara lokal di browser Anda. Gambar Anda dimuat ke memori perangkat menggunakan File API browser dan tidak pernah dikirim melalui internet. Rendering tanda air dilakukan pada elemen canvas HTML5 yang berjalan dengan JavaScript, sepenuhnya di dalam tab browser Anda. Saat Anda menutup halaman atau menekan “Start Over”, semua data gambar dilepaskan dari memori dan dibuang. Tidak ada yang disimpan di luar perangkat Anda.',
          ],
        },
        {
          id: 'wm-blog-summary',
          tocLabel: 'Ringkasan Akhir',
          title: 'Mengapa Alat Tanda Air Photremium Layak Masuk ke Alur Kerja Rutin Anda',
          paragraphs: [
            'Ada puluhan alat tanda air yang tersedia secara online. Yang membedakan alat yang layak dibookmark dari yang mudah dilupakan biasanya adalah kombinasi kecepatan, kontrol, dan kepercayaan.',
            'Kecepatan penting karena pemberian tanda air tidak boleh menambah banyak waktu pada alur pascaproses. Alat Photremium memuat instan, memproses secara lokal, dan mengekspor pada resolusi penuh dalam hitungan detik — bahkan untuk batch besar. Tidak ada menunggu pemrosesan server, tidak ada antrean, dan tidak ada waktu render yang meningkat seiring jumlah pengguna online pada saat bersamaan.',
            'Kontrol penting karena tanda air yang terlihat buruk lebih buruk daripada tidak memakai tanda air sama sekali — itu membuat brand Anda terlihat tidak profesional. Sistem lapisan, kontrol per properti di toolbar, pratinjau kanvas real-time, dan dukungan shortcut keyboard memberikan tingkat kontrol yang sebanding dengan software desktop khusus.',
            'Kepercayaan penting karena karya Anda yang belum dipublikasikan sangat berharga. Mengetahui bahwa gambar Anda tidak pernah melewati internet ke server pihak ketiga berarti Anda dapat memberi tanda air pada foto klien, gambar produk yang belum dirilis, dan karya kreatif sensitif tanpa khawatir tentang penanganan data, pelanggaran server, atau perubahan kebijakan penyedia cloud.',
            'Baik Anda menambahkan pemberitahuan hak cipta cepat pada satu foto atau memproses seluruh sesi 200 gambar untuk galeri klien, alat Tanda Air Gambar Photremium memberi Anda alat untuk melakukannya dengan benar — sepenuhnya gratis, sepenuhnya privat, dan cukup fleksibel agar tanda air terlihat menyatu dengan gambar, bukan sekadar ditempel di atasnya.',
            'Kunjungi photremium.com/watermark-image dan coba sendiri. Gambar bertanda air pertama Anda benar-benar hanya tiga puluh detik lagi.',
            'Photremium menawarkan rangkaian alat pengeditan dan pemrosesan gambar berbasis browser. Semua alat berjalan secara lokal di browser Anda — gambar Anda tetap berada di perangkat Anda.',
          ],
        },
      ],
    },
  },
  qrGenerator: {
    seo: {
      inputTitle: 'Generator Kode QR — Buat & Sesuaikan Gratis | photremium.com',
      inputDesc: 'Buat kode QR khusus untuk URL, teks, WiFi, kontak, email, dan lokasi Google Maps. Sesuaikan warna, bentuk, bingkai, logo, dan unduh dalam berbagai format.',
      inputKeywords: 'generator kode qr, buat kode qr, kode qr khusus, pembuat kode qr, kode qr gratis',
      customizeTitle: 'Sesuaikan Kode QR — Generator Kode QR photremium.com',
      customizeDesc: 'Sesuaikan gaya, warna, bingkai, dan logo kode QR Anda. Unduh dalam PNG, JPG, SVG, WEBP, atau PDF.',
      customizeKeywords: 'sesuaikan kode qr, gaya kode qr, warna kode qr, logo kode qr',
    },
    title: 'Generator Kode QR',
    desc: 'Buat, sesuaikan, dan unduh kode QR untuk URL, teks, WiFi, kontak, email & peta. Sepenuhnya gratis, berjalan di browser Anda.',
    generate: 'Buat',
    scanQrCode: 'Pindai Kode QR',
    tabUrl: 'Tautan / URL',
    tabText: 'Teks',
    tabWifi: 'WiFi',
    tabContact: 'Kontak',
    tabEmail: 'Gmail',
    tabMaps: 'Google Maps',
    enterUrl: 'Masukkan URL',
    enterText: 'Masukkan Teks',
    networkName: 'Nama Jaringan (SSID)',
    password: 'Kata Sandi',
    encryption: 'Enkripsi',
    hiddenNetwork: 'Jaringan Tersembunyi',
    contactName: 'Nama Kontak (opsional)',
    phoneNumber: 'Nomor Telepon',
    emailAddress: 'Alamat Email',
    subject: 'Subjek (opsional)',
    body: 'Isi (opsional)',
    searchLocation: 'Cari Lokasi',
    urlPlaceholder: 'https://contoh.com',
    textPlaceholder: 'Ketik teks Anda di sini…',
    wifiNamePlaceholder: 'WiFi Saya',
    passwordPlaceholder: 'Kata Sandi',
    contactPlaceholder: 'Budi Santoso',
    phonePlaceholder: '+62 XXX XXXX XXXX',
    emailPlaceholder: 'contoh@gmail.com',
    subjectPlaceholder: 'Subjek',
    bodyPlaceholder: 'Isi email…',
    locationPlaceholder: 'Cari kota, alamat, tempat…',
    wpaWpa2: 'WPA / WPA2',
    wep: 'WEP',
    none: 'Tidak Ada',
    characters: 'karakter',
    qrGettingComplex: 'Kode QR semakin kompleks — mungkin sulit dipindai.',
    qrTooComplex: 'Kode QR terlalu kompleks! Sebagian besar pemindai tidak dapat membacanya.',
    generateCustomize: 'Buat & Sesuaikan',
    editQrData: 'Edit Data QR',
    styleShape: 'Gaya & Bentuk',
    colorTab: 'Warna',
    framesTab: 'Bingkai',
    logoTab: 'Logo',
    templatesTab: 'Template',
    fileFormatTab: 'Format File',
    dotShape: 'Bentuk Titik',
    cornerEyeOuter: 'Mata Sudut — Luar',
    cornerEyeInner: 'Mata Sudut — Dalam',
    fgColor: 'Warna Depan',
    bgColor: 'Warna Latar',
    enableGradient: 'Aktifkan Gradien',
    gradientType: 'Tipe Gradien',
    linear: 'Linear',
    radial: 'Radial',
    gradientColor1: 'Warna Gradien 1',
    gradientColor2: 'Warna Gradien 2',
    suggestedGradients: 'Gradien yang Disarankan',
    selectFrame: 'Pilih Bingkai',
    selectLogo: 'Pilih Logo',
    uploadCustomLogo: 'Atau Unggah Logo Khusus',
    uploadImage: 'Unggah Gambar',
    customLogoApplied: 'Logo khusus diterapkan',
    premadeTemplates: 'Template Jadi',
    templateHint: 'Klik template untuk langsung menerapkan kombinasi gayanya.',
    downloadFormat: 'Format Unduh',
    fgBgIdentical: 'Warna depan dan latar belakang identik — Kode QR akan tidak terlihat!',
    fgBgSimilar: 'Warna depan dan latar belakang sangat mirip — Kode QR mungkin sulit dipindai.',
    preview: 'Pratinjau',
    angle: 'Sudut',
    downloadFormatBtn: 'Unduh {format}',
    pngDesc: 'Tanpa kerugian, dukungan transparan',
    jpgDesc: 'Format file populer/universal',
    webpDesc: 'Format modern, kualitas/ukuran terbaik',
    svgDesc: 'Grafik vektor yang dapat diskalakan',
    pdfDesc: 'Dokumen siap cetak',
    lat: 'Lat:',
    lng: 'Lng:',
    qrCode: 'Kode QR',
    scanMe: 'PINDAI SAYA',
    scanHere: 'PINDAI DI SINI',
    blog: {
      card1: {
        title: '1. Apa itu kode QR?',
        intro1: 'QR adalah singkatan dari “Quick Response”. Disebut demikian karena data di dalamnya dapat dibaca sangat cepat oleh pemindai.',
        intro2: 'Kode QR adalah kode digital dua dimensi yang dibaca mesin. Kode ini dapat menyimpan teks, nomor kontak, tautan, lokasi peta, dan data lainnya.',
        inventionTitle: 'Bagaimana kode QR ditemukan:',
        inventionText: 'Kode QR ditemukan pada tahun 1994 oleh Masahiro Hara dan timnya di Denso Wave, Jepang, untuk kebutuhan pelacakan komponen otomotif yang membutuhkan kapasitas lebih besar daripada barcode biasa.',
        keyFeaturesTitle: 'Fitur utama kode QR',
        keyFeatures: [
          {
            title: 'Cara kerja QR',
            text: 'Anda memasukkan teks atau tautan, lalu sistem mengubahnya menjadi pola kotak. Setiap pola mewakili bit data yang menyusun informasi.',
          },
          {
            title: 'Struktur kode QR',
            text: 'Kode QR memiliki tiga kotak penanda besar untuk orientasi serta banyak modul kecil untuk menyimpan data.',
          },
          {
            title: 'Kapasitas data kode QR',
            text: 'Kode QR umumnya menyimpan lebih banyak data daripada barcode satu dimensi. Semakin banyak karakter yang dimasukkan, semakin kompleks pola dan bisa lebih sulit dipindai.',
          },
          {
            title: 'Deteksi kesalahan pada kode QR',
            text: 'Kode QR tetap bisa dipindai meski sebagian rusak. Mekanisme koreksi kesalahan membantu memulihkan data saat ada gangguan kecil.',
          },
        ],
        errorTitle: 'Tingkat koreksi kesalahan kode QR:',
        errorIntro: 'Tingkat koreksi berikut digunakan sesuai kebutuhan penggunaan:',
        errorHeaders: {
          level: 'Level',
          recovery: 'Kapasitas pemulihan',
          bestUse: 'Penggunaan terbaik',
        },
        errorRows: [
          {
            level: 'Rendah (L)',
            recovery: '~7%',
            useCases: [
              'Cocok untuk tampilan digital, situs web, atau lingkungan bersih dengan risiko kerusakan rendah.',
              'Sesuai untuk data singkat seperti email, nomor kontak, atau teks pendek.',
            ],
          },
          {
            level: 'Sedang (M)',
            recovery: '~15%',
            useCases: [
              'Baik untuk flyer atau poster dalam kondisi umum dengan risiko kerusakan ringan.',
            ],
          },
          {
            level: 'Kuartil (Q)',
            recovery: '~25%',
            useCases: [
              'Disarankan untuk lingkungan luar ruang atau area kerja yang lebih keras.',
              'Ideal saat menggunakan logo kecil di tengah yang menutupi sebagian modul.',
            ],
          },
          {
            level: 'Tinggi (H)',
            recovery: '~30%',
            useCases: [
              'Dipakai ketika kemungkinan kerusakan fisik cukup tinggi.',
              'Cocok saat logo besar ditempatkan di tengah kode QR.',
              'Sesuai untuk desain kode QR yang sangat kustom.',
            ],
          },
        ],
      },
      card2: {
        title: '2. Mengapa memilih generator kode QR kami?',
        intro: 'Generator kode QR kami cepat, aman, dan mudah digunakan. Anda dapat menyesuaikan desain agar terlihat profesional dan selaras dengan identitas merek, tanpa biaya.',
        strengths: [
          {
            title: 'Kustomisasi profesional:',
            text: 'Buat dan sesuaikan sebanyak mungkin kode QR secara gratis dengan banyak opsi bentuk, warna, gradien, dan gaya.',
          },
          {
            title: 'Dukungan banyak format:',
            text: 'Anda dapat mengunduh kode QR dalam berbagai format. Pilih format sebelum mengunduh sesuai kebutuhan.',
          },
          {
            title: 'Template siap pakai:',
            text: 'Gunakan kombinasi warna gradien dan frame siap pakai agar hasil terlihat lebih profesional.',
          },
          {
            title: 'Dukungan logo kustom:',
            text: 'Unggah logo merek Anda sendiri atau pilih dari pustaka logo bawaan untuk ditempatkan otomatis di tengah kode QR.',
          },
          {
            title: 'Pratinjau langsung:',
            text: 'Semua perubahan desain terlihat secara real-time pada panel pratinjau saat Anda mengedit.',
          },
          {
            title: 'Indikator pemindaian:',
            text: 'Sistem memberi peringatan jika kombinasi warna berpotensi sulit dipindai.',
          },
        ],
        formatHeaders: {
          srNo: 'No',
          formats: 'Format',
          description: 'Deskripsi',
        },
        formatRows: [
          { no: '1', format: 'PNG', description: 'Tanpa kehilangan kualitas, mendukung transparansi' },
          { no: '2', format: 'JPG', description: 'Format populer dan universal' },
          { no: '3', format: 'WEBP', description: 'Format modern dengan rasio kualitas/ukuran terbaik' },
          { no: '4', format: 'SVG', description: 'Grafik vektor yang dapat diskalakan' },
          { no: '5', format: 'PDF', description: 'Dokumen siap cetak' },
        ],
      },
      card3: {
        title: '3. Panduan langkah demi langkah:',
        step1Intro: 'Pertama, pilih kategori kode QR yang ingin dibuat, seperti tautan, teks, WiFi, kontak, email, atau peta.',
        categories: ['Tautan / URL', 'Teks', 'WiFi', 'Kontak', 'Gmail', 'Google Maps'],
        step2: 'Setelah memilih kategori, masukkan data Anda pada kotak input yang tersedia.',
        step3Intro: 'Lalu klik Generate & Customize untuk membuka panel kustomisasi. Di sana tersedia opsi berikut:',
        options: [
          {
            title: 'Gaya & Bentuk:',
            text: 'Ubah bentuk modul QR menjadi berbagai gaya seperti sudut membulat, titik, batang horizontal, batang vertikal, dan lainnya.',
          },
          {
            title: 'Warna:',
            text: 'Pilih warna latar dan foreground, termasuk gradien linear atau radial. Anda juga dapat mengatur sudut gradien untuk hasil yang lebih rapi.',
          },
          {
            title: 'Frame:',
            text: 'Pilih bingkai dari pustaka bawaan agar kode QR terlihat lebih menarik tanpa mengganggu keterbacaan.',
          },
          {
            title: 'Logo:',
            text: 'Tambahkan logo ke tengah kode QR secara otomatis, termasuk dukungan unggah logo merek Anda sendiri.',
          },
          {
            title: 'Template:',
            text: 'Gunakan template siap pakai jika ingin hasil cepat tanpa mengatur setiap elemen secara manual.',
          },
          {
            title: 'Format File:',
            text: 'Pilih tipe file unduhan yang diinginkan seperti PNG, WEBP, SVG, atau PDF.',
          },
          {
            title: 'Edit Data QR:',
            text: 'Anda dapat mengubah isi data QR tanpa menghapus kustomisasi yang sudah dipilih.',
          },
        ],
        finalStep: 'Terakhir, klik tombol unduh. Kode QR akan langsung diunduh sesuai pengaturan dan format yang Anda pilih, tanpa biaya.',
      },
      card4: {
        title: '4. Manfaat:',
        intro: 'Kode QR menghubungkan dunia fisik dan digital dengan cepat. Cukup satu pemindaian untuk membuka tautan, kontak, atau lokasi secara instan.',
        benefits: [
          {
            title: 'Dukungan seumur hidup:',
            text: 'Kode QR tidak memiliki masa kedaluwarsa bawaan dan dapat digunakan dalam jangka panjang selama datanya tetap valid.',
          },
          {
            title: 'Dukungan offline:',
            text: 'Pemindaian tetap dapat dilakukan tanpa internet; perangkat akan membaca pola QR terlebih dahulu lalu menampilkan datanya.',
          },
          {
            title: 'Tanpa biaya:',
            text: 'Pembuatan kode QR dasar tidak memerlukan biaya tambahan dan dapat digunakan kapan saja.',
          },
        ],
      },
    },
  },
  qrScanner: {
    seo: {
      title: 'Pemindai Kode QR — Pindai Kode QR dari Kamera atau Gambar | photremium.com',
      desc: 'Pindai kode QR secara instan menggunakan kamera atau dengan mengunggah gambar. Deteksi URL, teks, WiFi, kontak, dan lainnya. Gratis, cepat, privat.',
      keywords: 'pemindai kode qr, pindai kode qr, pembaca qr, pembaca kode qr online, pindai qr dari gambar, pemindai qr kamera',
    },
    title: 'Pemindai Kode QR',
    desc: 'Pindai kode QR secara instan menggunakan kamera atau unggah gambar. Cepat, privat & aman — semuanya berjalan di browser Anda.',
    generateQrCode: 'Buat Kode QR',
    scan: 'Pindai',
    cameraScanner: 'Pemindai Kamera',
    uploadImage: 'Unggah Gambar',
    pointCamera: 'Arahkan kamera Anda ke kode QR',
    startCamera: 'Mulai Kamera',
    loading: 'Memuat…',
    dropQrImage: 'Letakkan gambar kode QR di sini',
    toScan: 'untuk dipindai',
    supportedFormats: 'Mendukung JPG, PNG, GIF, WEBP',
    ctrlVPaste: 'Ctrl+V untuk menempel',
    scanFromGallery: 'Pindai dari Galeri',
    instantScanning: 'Pemindaian Instan',
    instantScanningDesc: 'Deteksi kode QR secara real-time dari kamera atau gambar yang diunggah',
    private100: '100% Privat',
    private100Desc: 'Semua pemrosesan terjadi di browser Anda. Tidak ada yang diunggah',
    multiFormat: 'Multi-Format',
    multiFormatDesc: 'Deteksi URL, teks, WiFi, kontak, email, telepon & lainnya',
    accessingCamera: 'Mengakses kamera…',
    cameraDenied: 'Akses kamera ditolak. Harap izinkan izin kamera dan coba lagi.',
    noCamera: 'Tidak ada kamera yang ditemukan di perangkat ini.',
    cameraError: 'Tidak dapat mengakses kamera. Silakan coba lagi.',
    videoError: 'Tidak dapat memulai pemutaran video.',
    switchError: 'Tidak dapat beralih kamera.',
    tryAgain: 'Coba Lagi',
    switchCamera: 'Ganti Kamera',
    stop: 'Hentikan',
    noQrFound: 'Tidak Ada Kode QR Ditemukan',
    couldNotRead: 'Tidak dapat membaca gambar',
    scannerFailed: 'Pemindai gagal dimuat',
    noQrFoundDesc: 'Tidak ada kode QR yang terdeteksi dalam gambar. Coba gambar lain atau gunakan pemindai kamera.',
    qrScanned: 'Kode QR Dipindai!',
    openLink: 'Buka Tautan',
    copied: 'Disalin!',
    copy: 'Salin',
    share: 'Bagikan',
    scanAgain: 'Pindai Lagi',
    network: 'Jaringan',
    password: 'Kata Sandi',
    security: 'Keamanan',
    unknown: 'Tidak Diketahui',
    typeText: 'Teks',
    typeUrl: 'URL',
    typeWifi: 'Jaringan WiFi',
    typeContact: 'Kartu Kontak',
    typeEmail: 'Email',
    typePhone: 'Nomor Telepon',
    typeSms: 'SMS',
    typeLocation: 'Lokasi',
    blog: {
      tocTitle: 'Daftar Isi',
      sections: [
        {
          id: 'why-use-qr-code-scanner',
          title: '1. Mengapa menggunakan pemindai kode QR?',
          paragraphs: [
            'Pemindai kode QR pada dasarnya adalah kamera ponsel yang mendekode informasi yang tersimpan di dalam kode QR. Anda hanya perlu mengarahkan kamera ke kode QR; apa pun orientasinya, alat ini akan membaca pola tertentu, mendeteksi kesalahan, memperbaiki kesalahan bila diperlukan, dan menampilkan informasi di dalamnya.',
          ],
          listTitle: 'Jenis pemindai kode QR:',
          bullets: [
            'Pemindai kode QR berbasis web: Anda dapat memindai kode QR dengan pemindai online yang didukung browser Anda. Anda bisa mengakses informasi melalui kamera atau dengan mengunggah gambar. Untuk auto-redirect dan fitur lanjutan lainnya, Anda dapat mengunjungi https://photremium.com.',
            'Kamera ponsel: Beberapa ponsel modern memiliki pemindai kode QR bawaan di aplikasi kamera asli. Kamera ini dapat mengambil dan mendekode informasi hanya dengan memindai kode QR.',
            'Aplikasi: Ada aplikasi yang dibuat khusus untuk memindai kode QR. Namun, untuk redirect lanjutan dan banyak fitur lainnya, Anda dapat memasang aplikasi melalui tautan ini secara gratis: https://photremium.com.',
            'Perangkat keras: Beberapa perangkat keras juga dibuat untuk memindai kode QR. Perangkat ini banyak digunakan di pusat perbelanjaan besar untuk proses penagihan barang.',
          ],
        },
        {
          id: 'why-choose-our-qr-code-scanner',
          title: '2. Mengapa memilih pemindai kode QR kami?',
          paragraphs: [
            'Anda bisa mengeksplor berbagai fitur lanjutan mulai dari redirect hingga menyalin konten hasil decode dari kode QR. Anda juga dapat menemukan banyak fitur menarik lainnya di pemindai kode QR kami, seperti:',
          ],
          bullets: [
            'Kecepatan tinggi: Pemindai kode QR kami membuat proses decoding sangat cepat. Anda hanya perlu memindai kode QR, lalu alat kami langsung menampilkan informasi dengan opsi lanjutan untuk menyalin teks/tautan, membuka jika terdeteksi tautan, atau menyimpan otomatis jika terdeteksi kontak.',
            'Tanpa instalasi: Anda tidak perlu memasang aplikasi terpisah untuk mengakses pemindai kode QR kami. Anda dapat memakai alat ini lewat browser lokal secara gratis.',
            'Akses lintas platform: Anda dapat mengaksesnya di perangkat apa pun. Tidak perlu khawatir soal versi OS atau syarat lain. Alat ini didukung di semua versi dan semua perangkat.',
            'Semua format didukung: Semua format data yang bisa disimpan di dalam kode QR didukung, termasuk teks biasa, WiFi, URL, kontak, Gmail, dan Google Maps, dll.',
          ],
        },
        {
          id: 'step-by-step-guide',
          title: '3. Panduan langkah demi langkah:',
          steps: [
            {
              heading: '1. Pertama-tama, pilih metode untuk memindai kode QR. Ada dua metode berikut:',
              subSteps: [
                {
                  heading: 'i. Metode kamera',
                  paragraphs: [
                    'Anda dapat memindai kode QR menggunakan kamera perangkat, baik di laptop, PC, maupun perangkat lain yang mendukung kamera sederhana. Cukup klik tombol “Mulai Kamera”, lalu permintaan izin akan muncul; izinkan situs ini menggunakan kamera Anda untuk pemindaian QR. Jika Anda tidak sengaja menolak izin atau permintaan tidak muncul, Anda dapat memberi akses kamera secara manual dengan langkah berikut:',
                  ],
                  notes: [
                    '➔ Untuk Chrome (Android / Desktop):',
                    '1. Klik tiga titik',
                    '2. Buka Setelan',
                    '3. (Lewati langkah ini untuk Android) Privasi dan keamanan',
                    '4. Klik Setelan situs',
                    '5. Lalu di bagian izin, klik Kamera',
                    '6. Cari URL situs kami: https://photremium.com/qr-code-scanner',
                    '7. Atur izin kamera ke Allow pada dropdown.',
                    '➔ Untuk Safari (iPhone / iOS):',
                    '1. Ketuk ikon AA atau Pengaturan Situs Web di bilah alamat.',
                    '2. Pilih Website Settings.',
                    '3. Ketuk Camera lalu pilih Allow.',
                    '4. Jika masih terblokir: buka Pengaturan iPhone > Safari > Camera lalu set ke Ask atau Allow.',
                  ],
                },
                {
                  heading: 'ii. Metode galeri',
                  paragraphs: [
                    'Anda dapat mengunggah gambar kode QR untuk mengakses informasinya. Klik tombol “Pindai dari Galeri”, lalu file explorer akan terbuka. Setelah itu pilih gambar kode QR. Semua format gambar didukung seperti .jpg, .jpeg, .png, .gif, .webp, .svg, .avif, .heic, .heif, .jxl, .bmp, .ico, .tiff, .tif, .jfif, .jpe, .pjpeg, .pjp, .apng, .svgz, dan .xbm, dll.',
                  ],
                },
              ],
            },
            {
              heading: '2. Saat Anda memilih kode QR, semua informasi akan ditampilkan; memungkinkan Anda menyalin, membagikan, atau membuka tautan jika terdeteksi. Anda juga bisa memindai lagi jika mau.',
            },
          ],
        },
        {
          id: 'benefits-of-qr-code-scanner',
          title: 'Manfaat pemindai kode QR:.',
          paragraphs: [
            'Pemindai kode QR menawarkan berbagai manfaat di dunia digital ini. Alat ini membuat pembayaran, verifikasi, dan akses informasi menjadi mudah dan cepat bahkan dalam mode offline.',
          ],
          bullets: [
            'Akses informasi instan: Memindai kode QR memberikan informasi dalam hitungan milidetik. Alat ini mendekode pola, mendeteksi kesalahan, dan memperbaikinya sangat cepat, sehingga memberi pengalaman pengguna yang sangat cepat.',
            'Komunikasi mulus: Di era kemajuan ini, ada kebutuhan tinggi akan komunikasi cepat dan aman untuk informasi kecil seperti detail bank dan detail produk, dll. Pemindai kode QR menyelesaikan masalah ini karena pembayaran dapat dilakukan dengan memindai kode QR. Selain itu, Google memverifikasi ponsel melalui QR saat membuat akun baru di laptop.',
            'E-Tickets: Di terminal bus, stasiun kereta, atau bandara, Anda dapat memverifikasi tiket dengan mudah tanpa menunggu lama di antrean. Selain itu, pemindai QR dipasang di banyak titik bandara untuk mengurangi antrean. Hal ini juga meminimalkan kebutuhan pegawai, sehingga otomatis menghemat anggaran maskapai.',
            'Autentikasi produk: Merek premium dan berteknologi tinggi memasang kode QR pada produknya. Pelanggan dapat memindai kode QR tersebut untuk mengecek keaslian produk, apakah asli atau tidak.',
          ],
        },
      ],
    },
  },
  faceBlur: {
    seo: {
      uploadTitle: 'Alat Blur Wajah — Blur Wajah dalam Gambar Online | photremium.com',
      uploadDesc: 'Blur wajah dalam gambar Anda secara otomatis dengan deteksi wajah AI. Pilih intensitas blur, bentuk, atau overlay emoji. 100% gratis, cepat & privat.',
      uploadKeywords: 'blur wajah, blur wajah, deteksi wajah, alat privasi, blur wajah online gratis',
      workspaceTitle: 'Alat Blur Wajah — Blur Wajah dalam Gambar Online | photremium.com',
      workspaceDesc: 'Blur wajah dalam gambar Anda secara otomatis. 100% gratis, cepat & privat.',
      workspaceKeywords: 'blur wajah, blur wajah, deteksi wajah',
    },
    title: 'Blur Wajah',
    desc: 'Deteksi dan blur wajah secara otomatis dalam gambar Anda untuk privasi. Pilih intensitas blur, bentuk, atau tutupi wajah dengan emoji lucu. 100% sisi klien — gambar Anda tidak pernah meninggalkan perangkat Anda.',
    toBlurFaces: 'untuk memblur wajah',
    autoDetection: 'Deteksi Otomatis',
    autoDetectionDesc: 'Deteksi wajah bertenaga AI menemukan semua wajah secara instan',
    customBlur: 'Blur Khusus',
    customBlurDesc: 'Sesuaikan intensitas blur, bentuk, dan gaya',
    private100: '100% Privat',
    private100Desc: 'Semua pemrosesan terjadi secara lokal di browser Anda',
    blurTools: 'Alat Blur',
    faces: 'Wajah',
    faceDetection: 'Deteksi Wajah',
    detecting: 'Mendeteksi...',
    autoDetectFaces: 'Deteksi Wajah Otomatis',
    exitManualMode: 'Keluar Mode Manual',
    manualSelect: 'Pilih Manual',
    nFaceRegions: '{n} area wajah ditemukan',
    noFacesDetected: 'Tidak ada wajah terdeteksi — gunakan mode manual',
    manualHint: 'Klik dan seret pada gambar untuk menggambar persegi panjang di atas area yang ingin Anda blur.',
    blurType: 'Tipe Blur',
    blur: 'Blur',
    emoji: 'Emoji',
    blurIntensity: 'Intensitas Blur',
    strength: 'Kekuatan',
    blurShape: 'Bentuk Blur',
    rectangle: 'Persegi Panjang',
    ellipse: 'Lingkaran',
    circle: 'Lingkaran',
    chooseEmoji: 'Pilih Emoji',
    blurRegionsN: 'Area Blur ({n})',
    faceN: 'Wajah {n}',
    manualRegionN: 'Area Manual {n}',
    manualN: 'Manual {n}',
    clearAllRegions: 'Hapus Semua Area',
    processingDots: 'Memproses...',
    downloadBlurred: 'Unduh Gambar yang Diblur',
    downloadNImages: 'Unduh {n} Gambar',
    downloadDialogTitle: 'Tidak semua gambar diedit',
    downloadDialogText: 'Anda telah mengedit {edited} dari {total} gambar.',
    downloadAll: 'Unduh Semua',
    removeRegion: 'Hapus area',
    region: 'Area',
    notAllEdited: 'Tidak semua gambar diedit',
    editedXofY: 'Anda telah mengedit {edited} dari {total} gambar.',
    nextImage: 'Gambar Berikutnya',
  },
  faqData: {
    imageConverter: [
      { q: 'Format gambar apa yang didukung untuk konversi?', a: 'Kami mendukung JPG, PNG, WEBP, SVG, GIF, BMP, ICO, dan TIFF. Anda dapat mengonversi antara format-format ini secara instan di browser Anda.' },
      { q: 'Apakah kualitas gambar akan terpengaruh selama konversi?', a: 'Untuk format lossless seperti PNG, kualitas sepenuhnya dipertahankan. Untuk format lossy seperti JPG dan WEBP, kami menggunakan pengaturan encoding yang dioptimalkan untuk mempertahankan kualitas visual terbaik.' },
      { q: 'Apakah ada batasan ukuran file atau jumlah?', a: 'Tidak ada batasan keras — Anda dapat mengunggah beberapa gambar sekaligus dan mengonversinya secara massal. Karena semuanya berjalan secara lokal di browser Anda, kecepatan bergantung pada perangkat Anda.' },
      { q: 'Apakah data saya aman? Apakah gambar diunggah ke server?', a: 'Tentu saja. Semua pemrosesan terjadi 100% di browser Anda. Gambar Anda tidak pernah meninggalkan perangkat Anda, memastikan privasi dan keamanan penuh.' },
      { q: 'Bisakah saya mengonversi gambar PNG transparan ke JPG?', a: 'Ya. Karena JPG tidak mendukung transparansi, area transparan akan diisi dengan latar belakang putih secara default, menghasilkan hasil yang bersih.' },
    ],
    imageCompressor: [
      { q: 'Apakah mengompres gambar akan menurunkan kualitasnya?', a: 'Tidak, kompresi tidak akan memengaruhi kualitas gambar selama Anda tidak melampaui batas yang disarankan. Indikator kualitas membantu Anda: i. Kompresi 1% hingga 40%: indikator hijau dengan pesan “Kualitas baik”. ii. Kompresi 41% hingga 60%: indikator kuning dengan pesan “Kualitas normal”. Rentang ini paling direkomendasikan untuk hasil terbaik. iii. Kompresi 61% hingga 100%: sistem menampilkan peringatan merah dengan pesan “Kualitas buruk”. Pada rentang ini, penurunan kualitas bisa terlihat jelas.' },
      { q: 'Format gambar apa saja yang didukung untuk kompresi?', a: 'Alat kompresor gambar kami mendukung semua format berikut:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: 'Bisakah saya mengompres banyak gambar sekaligus?', a: 'Tentu bisa. Anda dapat mengompres banyak gambar sekaligus (bahkan 100+), tergantung kemampuan perangkat Anda. Karena proses kompresi menggunakan sumber daya perangkat, laptop/PC/ponsel dengan performa tinggi akan bekerja lebih cepat. Jika perangkat Anda berspesifikasi rendah, Anda tetap bisa mengompres secara bertahap karena alat ini gratis digunakan, termasuk untuk banyak batch.' },
      { q: 'Apakah gambar saya disimpan atau diunggah ke server Anda?', a: 'Tidak. Kami tidak pernah mengunggah atau menyimpan gambar Anda di server kami. Semua proses kompresi dilakukan secara lokal di browser Anda. Gambar Anda tidak pernah meninggalkan perangkat, sehingga aman untuk gambar pribadi maupun sensitif.' },
      { q: 'Apakah alat kompresi gambar ini gratis?', a: 'Ya, alat kompresor gambar kami sepenuhnya gratis selamanya. Kami tidak akan pernah meminta pembayaran apa pun. Tidak ada biaya tersembunyi. Semua fitur, termasuk kompresi banyak gambar, tersedia gratis.' },
    ],
    cropImage: [
      { q: 'Apakah memotong gambar akan menurunkan kualitasnya?', a: 'Tidak, memotong gambar tidak akan memengaruhi kualitas visual gambar sama sekali. Memotong gambar hanya membuang bagian yang tidak diinginkan. Itu tidak pernah mengubah piksel dari bagian gambar yang akan dipotong. Jadi, Anda dapat memotong gambar Anda dengan kualitas aslinya tanpa kerusakan piksel apa pun.' },
      { q: 'Format gambar apa yang didukung untuk pemotong gambar?', a: 'Anda dapat memilih gambar dalam format apa pun karena alat pemotong gambar kami menawarkan hampir semua format gambar. Ini tercantum di bawah ini:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: 'Apakah gambar saya diunggah ke server Anda?', a: 'Tidak, semua pemrosesan akan dilakukan di browser lokal Anda. Gambar Anda tidak akan pernah diunggah ke server kami karena gambar tidak pernah meninggalkan perangkat Anda. Jadi, Anda dapat memotong gambar pribadi Anda dengan pemotong gambar kami tanpa risiko apa pun.' },
      { q: 'Bisakah saya memotong beberapa gambar sekaligus?', a: 'Ya, Anda dapat memotong beberapa gambar (bahkan 100+) sekaligus jika sistem Anda mendukung. Karena memotong gambar menggunakan sumber daya sistem Anda, jadi jika Anda memiliki laptop, PC, atau ponsel berperforma tinggi, Anda dapat memotong banyak gambar sekaligus. Jika Anda memiliki perangkat kelas bawah, Anda dapat memotong gambar dalam batch karena alat ini gratis digunakan bahkan jika Anda memotong banyak gambar sekaligus.' },
      { q: 'Apakah alat pemotong gambar ini gratis untuk digunakan?', a: 'Ya, alat pemotong gambar ini sepenuhnya gratis untuk digunakan selamanya. Anda dapat mengakses alat ini di mana saja, kapan saja, dan menggunakan perangkat apa saja. Anda tidak hanya akan merasakan desain responsif untuk semua perangkat tetapi juga tidak akan pernah diminta membayar untuk fitur premium apa pun. Semua fitur sepenuhnya gratis tanpa biaya tersembunyi.' },
    ],
    resizeImage: [
      { q: 'Bisakah saya mengubah ukuran beberapa gambar sekaligus?', a: 'Tentu, alat resize gambar kami memungkinkan Anda mengubah ukuran banyak gambar sekaligus. Anda cukup mengunggah sebanyak gambar yang didukung perangkat Anda, lalu mesin AI kami akan mengubah ukuran semuanya sekaligus. Namun jika Anda memiliki perangkat kelas bawah, coba lakukan resize dalam beberapa batch untuk menghindari lag. Proses resize memakai sumber daya perangkat agar tidak perlu upload ke server sehingga privasi gambar Anda tetap terjaga.' },
      { q: 'Apakah alat resize gambar ini gratis digunakan?', a: 'Ya, alat ini gratis untuk digunakan selamanya. Anda tidak akan pernah diminta berlangganan berbayar untuk membuka fitur premium apa pun. Tidak ada biaya tersembunyi saat mengunduh gambar hasil resize Anda.' },
      { q: 'Apakah mengubah ukuran gambar akan menurunkan kualitasnya?', a: '✅Decrease Size (downscale): Mengurangi ukuran gambar tidak akan menurunkan kualitas visual gambar. Bahkan, gambar hasil resize bisa terlihat lebih tajam daripada aslinya. Jadi, mengubah gambar ke dimensi yang lebih kecil tidak akan menurunkan kualitasnya.\n❌Increase Size (upscale): Meningkatkan ukuran di atas ukuran asli dapat memengaruhi kualitas visual gambar. Tingkat dampaknya bergantung pada seberapa besar peningkatan ukuran. Semakin besar Anda memperbesar, semakin turun kualitasnya.' },
      { q: 'Apakah alat resize gambar ini aman digunakan?', a: 'Ya, alat resize gambar kami sepenuhnya aman digunakan, terutama untuk gambar pribadi dan privat Anda karena semua gambar diproses secara lokal. Tidak ada data Anda yang akan meninggalkan perangkat dalam bentuk apa pun saat pemrosesan. Jadi, Anda bisa mengubah ukuran gambar pribadi tanpa risiko.' },
      { q: 'Format gambar apa saja yang didukung?', a: 'Semua format gambar didukung oleh alat resize gambar kami. Anda dapat memilih gambar dalam format berikut:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
    ],
    removeBackground: [
      { q: 'Bagaimana cara kerja penghapusan latar belakang?', a: 'Kami menggunakan model AI canggih yang berjalan langsung di browser Anda untuk mendeteksi subjek dan memisahkannya dari latar belakang, menghasilkan PNG transparan.' },
      { q: 'Apakah berfungsi dengan latar belakang yang kompleks?', a: 'Ya. Model AI menangani berbagai macam pemandangan termasuk latar belakang ramai, gradien, dan subjek warna serupa. Hasil terbaik dengan kontras subjek–latar belakang yang jelas.' },
      { q: 'Bisakah saya menghapus latar belakang dari beberapa gambar sekaligus?', a: 'Ya. Unggah beberapa gambar dan alat akan memprosesnya secara berurutan. Anda dapat mengunduh semua hasilnya sebagai ZIP atau satu per satu.' },
      { q: 'Apa format outputnya?', a: 'Output selalu berupa file PNG dengan latar belakang transparan, yang dapat Anda lapisi di atas desain apa pun.' },
      { q: 'Apakah gambar saya dikirim ke server?', a: 'Tidak. Model AI berjalan sepenuhnya di browser Anda menggunakan WebAssembly. Gambar Anda tetap ada di perangkat Anda setiap saat.' },
    ],
    watermarkImage: [
      { q: '1. Apakah alat Watermark Photremium sepenuhnya gratis?', a: 'Ya, alat watermark di photremium.com/watermark-image sepenuhnya gratis tanpa akun dan tanpa langganan. Anda dapat memberi watermark pada satu gambar atau satu batch penuh tanpa paywall, tanpa pendaftaran wajib, dan tanpa batas unduhan. Alat ini didukung karena nilai platform Photremium secara keseluruhan, bukan dengan mengunci fitur inti.' },
      { q: '2. Berapa banyak gambar yang bisa saya watermark sekaligus?', a: 'Alat ini mendukung watermark batch untuk banyak gambar. Anda bisa menyeret satu folder penuh ke area unggah atau memilih puluhan file dengan Ctrl+Click. Strip thumbnail di kiri menampilkan semuanya, dan ketika Anda klik "Watermark & Download All", alat akan merender setiap gambar lalu mengemasnya dalam ZIP (atau mengunduhnya sebagai file terpisah — sesuai pilihan Anda). Secara praktis, batasnya adalah memori perangkat Anda, bukan batas buatan.' },
      { q: '3. Format apa yang didukung untuk input dan output?', a: 'Input menerima format yang dapat ditangani oleh File API browser — biasanya JPEG, JPG, PNG, WEBP, GIF (statis), BMP, dan SVG. Output mempertahankan format asli: jika Anda unggah PNG, Anda mendapat PNG; jika unggah JPEG, Anda mendapat JPEG dengan kualitas 0.95. Ini mencegah konversi PNG lossless menjadi JPG lossy tanpa sengaja.' },
      { q: '4. Apakah watermark akan terlihat sama pada gambar dengan resolusi berbeda?', a: 'Ya, melalui mesin reposisi proporsional. Saat Anda memiliki batch dengan dimensi berbeda, watermark dibuat pada gambar referensi (yang sedang aktif di kanvas). Saat ekspor, mesin menghitung posisi setiap layer sebagai offset fraksional dari pusat gambar referensi lalu menerapkan offset yang sama pada gambar lain. Ukuran watermark juga diskalakan secara proporsional menggunakan faktor skala yang lebih kecil (rasio lebar vs tinggi) agar tidak melewati batas gambar. Hasilnya: watermark mempertahankan posisi dan ukuran relatif di seluruh batch.' },
      { q: '5. Bisakah saya menggunakan logo atau tanda tangan sebagai watermark alih-alih teks?', a: 'Tentu. Tombol "Add Image" di panel kanan memungkinkan Anda mengunggah file gambar sebagai layer watermark. PNG dengan background transparan paling ideal — transparansi tetap terjaga sehingga hanya logo yang terlihat. Anda dapat mengubah ukuran dengan handle sudut (rasio otomatis tetap), memutar, membalik, mengatur opasitas, bahkan menambah border atau sudut membulat. Banyak pengguna menyiapkan versi logo transparan khusus untuk watermark.' },
      { q: '6. Bagaimana membuat watermark transparan atau semi-transparan?', a: 'Pilih layer watermark di kanvas. Di toolbar atas akan ada kontrol opasitas dengan persentase — Anda bisa mengetik angka atau menggeser. Untuk watermark yang halus dan profesional, 30–50% biasanya ideal. Untuk watermark yang lebih tegas, 70–80% bekerja baik. Anda juga dapat membandingkan dengan menyalakan/mematikan layer melalui ikon mata di layer manager.' },
      { q: '7. Bisakah saya menambahkan beberapa watermark pada satu gambar?', a: 'Ya — sistem layer mendukung jumlah watermark tak terbatas, masing-masing dapat dikonfigurasi sendiri. Anda dapat memiliki teks hak cipta di kanan bawah, logo di kiri atas, dan overlay "SAMPLE" berubin secara bersamaan. Tiap layer punya opasitas, rotasi, posisi, ukuran, dan gaya sendiri. Layer manager membantu mengatur dan memungkinkan toggle tanpa menghapus untuk mencoba kombinasi berbeda.' },
      { q: '8. Apa fungsi tiling dan kapan sebaiknya digunakan?', a: 'Tiling mengulang watermark dalam pola grid di seluruh gambar. Grid 2×2 menempatkan empat salinan; Grid 3×3 menempatkan sembilan. Kontrol jarak mengatur celah antar salinan. Tiling berguna saat Anda ingin gambar tidak dapat digunakan ulang tanpa izin — watermark tunggal di sudut bisa dipotong, sedangkan pola penuh sulit dihapus tanpa merusak gambar. Ini umum untuk preview kontrak, draft karya, atau konten sebelum pembayaran.' },
      { q: '9. Apakah alat ini bekerja di ponsel dan tablet?', a: 'Ya, alat ini sepenuhnya responsif dan dirancang untuk mobile. Pada layar di bawah 900px, layout tiga panel berubah menjadi bertumpuk: strip thumbnail menjadi baris horizontal, kanvas tetap di tengah, dan panel pengaturan menjadi lembar bawah yang dibuka dengan tombol gear mengambang. Semua interaksi — drag, resize handle, rotasi — mendukung sentuhan. Handle sedikit lebih besar di mobile (16×16 px) agar mudah disentuh.' },
      { q: '10. Apakah data gambar saya pribadi? Apakah foto diunggah ke server?', a: 'Gambar Anda tidak pernah meninggalkan perangkat. Seluruh alur watermark — memuat gambar, merender layer, mengekspor file akhir — berjalan di browser menggunakan JavaScript dan HTML5 Canvas API. File API membuat representasi di memori, layer digambar ke canvas tersembunyi, dan saat download data piksel diubah menjadi Blob untuk diunduh secara lokal. Tidak ada request jaringan yang membawa data gambar. Selain itu, ada penjaga saat keluar halaman: jika Anda menutup halaman saat gambar masih dimuat, browser akan meminta konfirmasi untuk mencegah kehilangan pekerjaan.' },
    ],
    qrCodeGenerator: [
      { q: 'Apakah kode QR ini kedaluwarsa?', a: 'Tidak, kode QR ini tidak memiliki masa kedaluwarsa dan dapat digunakan seumur hidup. Karena kode ini menyimpan instruksi yang dikodekan permanen dalam bentuk bit di dalam kotak-kotak, informasi di dalamnya tidak dapat diubah atau dihapus. Anda tetap dapat mengakses informasi tersebut hanya dengan memindainya menggunakan kamera apa pun, bahkan setelah bertahun-tahun.' },
      { q: 'Mengapa kode QR saya tidak bisa dipindai?', a: 'Kode QR Anda mungkin gagal dipindai karena alasan berikut: i. Kontras rendah: Jika warna latar belakang dan warna depan terlalu mirip, visibilitas kode QR menurun dan pemindaian bisa gagal. Namun, alat kami akan memberi panduan saat kustomisasi jika terdeteksi kontras rendah atau masalah pemindaian lainnya. ii. Data terlalu besar: Jika Anda membuat kode QR untuk teks yang sangat panjang, kode menjadi sangat kompleks dan sulit dipindai. Validator panjang teks akan membantu Anda dengan panjang teks yang optimal. iii. Hasil cetak buram: Pastikan Anda mengunduh kode QR dalam format resolusi tinggi seperti PNG atau SVG yang sudah didukung alat kami.' },
      { q: 'Bisakah saya menambahkan logo ke dalam kode QR?', a: 'Tentu saja, Anda dapat menambahkan logo kustom atau memilih logo dari pustaka logo bawaan untuk kode QR Anda. Logo yang dipilih akan disesuaikan secara otomatis di bagian tengah kode QR.' },
      { q: 'Bagaimana cara memindai kode QR?', a: 'Anda dapat memindai kode QR menggunakan kamera ponsel Anda. Untuk pengalihan tautan otomatis dan fitur lanjutan lainnya, Anda juga bisa menggunakan pemindai kode QR kami secara gratis di https://photremium.com/qr-code-scanner.' },
      { q: 'Berapa banyak kode QR yang bisa saya buat gratis?', a: 'TANPA BATAS! Anda dapat membuat banyak kode QR secara gratis. Semua fitur, kustomisasi, dan template gratis selamanya untuk semua pengguna. Tidak perlu berlangganan untuk menikmati fitur premium.' },
      { q: 'Apakah saya perlu login/daftar untuk membuat kode QR?', a: 'Tidak. Cukup masukkan teks Anda, buat kode QR, lalu unduh setelah dikustomisasi. Tidak perlu login atau daftar karena semua fitur dapat diakses sepenuhnya gratis.' },
    ],
    qrCodeScanner: [
      { q: 'Bisakah saya memindai kode QR dari gambar tersimpan dan tangkapan layar?', a: '**Ya**, Anda bisa memindai kode QR dari gambar tersimpan atau tangkapan layar. Pemindai kode QR kami di https://photremium.com/qr-code-scanner memungkinkan Anda memindai dari galeri. Anda cukup memilih gambarnya dan semua informasi yang didekode dari kode QR tersebut akan ditampilkan.' },
      { q: 'Apakah saya perlu menginstal aplikasi untuk pemindai kode QR?', a: '**Tidak**, pemindai kode QR berbasis web kami memungkinkan Anda memindai tanpa instalasi aplikasi apa pun. Anda bisa mengakses pemindai QR lanjutan kami di perangkat apa pun secara gratis.' },
      { q: 'Mengapa pemindai tidak mengenali kode QR?', a: 'Kode QR Anda tidak terbaca karena salah satu alasan berikut: i. Cahaya tidak memadai: Memindai dalam cahaya redup dapat menyebabkan masalah. Nyalakan flash dan tingkatkan kecerahan jika Anda memindai dari layar. ii. Jarak: Memindai dari jarak yang tidak tepat juga menyebabkan masalah. Jarak optimal untuk memindai kode QR adalah sekitar 10 inci (25 cm). iii. Lensa kamera kotor: Kode QR juga bisa gagal dipindai karena lensa kotor. Bersihkan lensa sebelum memindai. “Anda melihat kotak grid di pemindai? Cukup pas-kan kode QR di dalamnya agar berhasil dipindai.”' },
      { q: 'Apakah alat ini bisa memindai kode QR terbalik atau berwarna?', a: '**Ya**, Anda bisa memindai QR dalam warna apa pun atau orientasi apa pun. Namun, jika kontras warna latar belakang dan foreground terlalu rendah, pemindaian bisa menjadi sulit.' },
      { q: 'Apakah alat ini gratis?', a: '**Ya**, alat ini sepenuhnya gratis. Anda bisa memindai kode QR tanpa batas secara gratis selamanya.' },
    ],
    faceBlur: [
      { q: 'Bagaimana cara kerja deteksi wajah?', a: 'Kami menggunakan model deteksi wajah bertenaga AI yang berjalan langsung di browser Anda. Model ini mengidentifikasi wajah dalam gambar sehingga Anda dapat menerapkan efek blur.' },
      { q: 'Bisakah saya memilih wajah mana yang akan diblur?', a: 'Ya. Setelah deteksi, setiap area wajah disorot dan Anda dapat memilih mana yang akan diblur dan menyesuaikan intensitas blur untuk masing-masing.' },
      { q: 'Gaya blur apa yang tersedia?', a: 'Anda dapat memilih dari blur Gaussian, pikselasi, atau overlay warna solid. Intensitas setiap efek dapat disesuaikan sepenuhnya.' },
      { q: 'Bisakah saya memblur wajah dalam beberapa gambar sekaligus?', a: 'Ya. Unggah beberapa gambar, konfigurasikan area blur, dan unduh semua gambar yang diproses bersama sebagai ZIP atau secara individual.' },
      { q: 'Apakah foto saya dikirim ke server jarak jauh?', a: 'Tidak. Model AI berjalan di browser Anda menggunakan WebAssembly. Foto Anda tidak pernah diunggah ke server mana pun.' },
    ],
    photoEditor: [
      { q: 'Fitur pengeditan apa yang tersedia?', a: 'Anda dapat menyesuaikan kecerahan, kontras, saturasi, menerapkan filter, menambahkan teks, overlay, bingkai, stiker, dan banyak lagi — semuanya di dalam browser Anda.' },
      { q: 'Bisakah saya membatalkan dan mengulang perubahan?', a: 'Ya. Editor mendukung riwayat undo/redo penuh sehingga Anda dapat bereksperimen dengan bebas tanpa khawatir kehilangan pekerjaan Anda.' },
      { q: 'Format file apa yang bisa saya edit dan ekspor?', a: 'Anda dapat mengedit JPG, PNG, WEBP, dan format umum lainnya. Gambar yang diedit dapat diekspor dalam format dan kualitas pilihan Anda.' },
      { q: 'Apakah editor bekerja di ponsel?', a: 'Ya. Editor sepenuhnya responsif dan ramah sentuhan, sehingga Anda dapat mengedit gambar di ponsel atau tablet Anda.' },
      { q: 'Apakah gambar saya disimpan di server Anda?', a: 'Tidak. Semua pengeditan dilakukan secara lokal. Gambar Anda tidak pernah meninggalkan perangkat Anda.' },
    ],
  },
};

export default id;
